// Scripts.jsx
import { useState, useEffect, useCallback, useRef } from "react";
import { createPortal } from "react-dom";

/* ── Icons ── */
const ChevronRight = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);
const AlertTriangle = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#ffb4ab"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const BotIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#06b6d4"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M12 11V7" />
    <circle cx="12" cy="5" r="2" />
    <line x1="8" y1="15" x2="8" y2="15" strokeWidth="3" />
    <line x1="16" y1="15" x2="16" y2="15" strokeWidth="3" />
    <line x1="9" y1="18" x2="15" y2="18" />
  </svg>
);
const PeopleIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#06b6d4"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);
const ChatIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#06b6d4"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);
const ArrowsIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#06b6d4"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 16V4m0 0L3 8m4-4l4 4" />
    <path d="M17 8v12m0 0l4-4m-4 4l-4-4" />
  </svg>
);
const SwitchIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#06b6d4"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="17 1 21 5 17 9" />
    <path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" />
    <path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const ListIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#06b6d4"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="8" y1="6" x2="21" y2="6" />
    <line x1="8" y1="12" x2="21" y2="12" />
    <line x1="8" y1="18" x2="21" y2="18" />
    <line x1="3" y1="6" x2="3.01" y2="6" />
    <line x1="3" y1="12" x2="3.01" y2="12" />
    <line x1="3" y1="18" x2="3.01" y2="18" />
  </svg>
);
const BankIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#06b6d4"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="3" y1="22" x2="21" y2="22" />
    <line x1="6" y1="18" x2="6" y2="11" />
    <line x1="10" y1="18" x2="10" y2="11" />
    <line x1="14" y1="18" x2="14" y2="11" />
    <line x1="18" y1="18" x2="18" y2="11" />
    <polygon points="12 2 20 7 4 7 12 2" />
  </svg>
);
const NoteIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#06b6d4"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
  </svg>
);
const LockIcon = () => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#06b6d4"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
const CloseIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);
const LiveDot = () => (
  <span
    style={{
      display: "inline-block",
      width: "7px",
      height: "7px",
      background: "#06b6d4",
      borderRadius: "50%",
      marginRight: "7px",
      animation: "pulse-live 2s ease-in-out infinite",
    }}
  />
);

/* ── Script Data (complete, verbatim) ── */
const scriptData = {
  Greeting: {
    type: "script",
    sections: [
      {
        label: "THE OPENING",
        text: `Agent: "Good _____ (morning/afternoon), this is _____ (agent) speaking, how may I help you today?"\n\nCaller: "Hi, is this _____ (company name)?" (write down the company name)`,
      },
      {
        label: "THE PIVOT",
        text: `Agent: "That's one of the carriers I can help you with. Were you calling about a policy on yourself, or a loved-one's?"\n\nCaller: "I'm calling about my policy."\n\nAgent: "Okay."`,
      },
    ],
  },

  "Gathering Information": {
    type: "script",
    sections: [
      {
        label: "VERIFY INFO",
        text: `1. "Go ahead and verify the spelling of your first and last name."\n2. "Verify your date of birth."\n\nAgent: "Okay, and how can I help you today?"\n\nCaller: <states reason for their call> (write this reason down)`,
      },
      {
        label: "REASON FOR CALL & POLICY DETAILS",
        text: `Agent: "Sure, I can definitely help you out with that. To get started, I will need to verify a few things to pull up information in my system. Go ahead and\n\n4. Verify approximately how long you've had this policy for.\n5. Last thing I need, please verify the amount that comes out of your checking account each month, as well as the total coverage amount on your policy."`,
      },
      {
        label: "HOLD TRANSITION",
        text: `Agent: "Thank you so much. I'm going to place you on a brief hold while I pull up some information here in my system, and I will be right back on the line to help you _____ (repeat what they called in for)."\n\nPlace the customer on hold and ask for an angle.`,
      },
    ],
  },

  "New Policy Quote": {
    type: "script",
    sections: [
      {
        label: "DISCOVERY",
        text: `Caller: "I'm calling to find out, how much would a policy cost?"\n\nAgent: "Sure! I can absolutely help you with that."\n\nDiscovery questions:\n• Do you currently have life insurance coverage?\n• Have you ever had life insurance in the past?\n• When you pass away are you looking to have a burial or cremation, funeral, what are your goals with this policy?\n• God forbid if you were to pass away tomorrow, would you like to leave anything behind for your beneficiaries?\n• By the way, who would you like your beneficiary to be? (get beneficiary's name)\n\nAgent: Gather info (name/DOB) & place on hold (gather standard/preferred rates)`,
      },
      {
        label: "QUOTE INTRO",
        text: `Agent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I'll be more than happy to get you that quote. So, you mentioned you'd like to cover a _____ (burial/cremation, etc.) and leave some money behind for _____ (beneficiary name). The average cost of a _____ (burial/cremation, etc.) today is between $15k-$20k. So, we definitely want to make sure you're adequately covered." (Pause)\n\nCaller: <says their response> (take note of their life insurance needs)`,
      },
      {
        label: "HEALTH CHECK",
        text: `Agent: "As you know, life insurance prices are based on 2 main factors, your age and your health. Let me ask you this, are you still healthy?" (Pause)\n\nCaller: "Yes, I'm still healthy!"\n\nAgent: "No heart attack, cancer, stroke, COPD, diabetes?" (Pause)\n\nCaller: "No, none of those." -or- "Yes, I have _____." (diabetes) (gather health info)`,
      },
      {
        label: "PREFERRED ANGLE",
        text: `Agent: "Okay, well you may be eligible for the preferred plan, which is for people who are healthy, and gives you better benefits and the best rates, so that's what we'll be shooting for. Since I am a broker for the state, I help with 40 different companies and I'm actually able to see all the going rates to make sure you'll be in the best position possible with your life insurance. So, let me take a look here, okay?" (Pause)\n\nCaller: "Okay"`,
      },
      {
        label: "HOOK",
        text: `Agent: "Actually, when I put your information here into my system, I am seeing something that I'm just a little confused about." (Pause)\n\nCaller: "Okay?? What is it?"\n\nAgent: "Well, it's showing me that a while ago, another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life) tried to reach out to you, and they tried to activate the preferred rate on a ______ (whole life) policy for ____ ($20k) to cover your _____ (burial/cremation, etc.) and leave some money behind for _____ (beneficiary name). Why didn't you take advantage of that when you had the chance?" (Pause)\n\nCaller: States their reason: Didn't know about it.\n\nAgent: "Hmm… that makes sense why it was never accepted or declined." (pause) "Today's standard rate on that coverage is about $XXX.XX. But they tried to activate it for you at the preferred rate for only $XXX.XX. But you said no one reached out to you on that? You just didn't know about it?"\n\nCaller: "Well yes, maybe they reached out, but I just never knew about it."\n\nAgent: "Well, obviously if you would have known about it, you would have taken advantage of that, correct?"\n\nCaller: "Yes of course I would have!"\n\nAgent: "Okay, well here's what I'm going to do (pause). I'm just going to see if they will let me go back and reinstate that, because like I said, it was never accepted or declined. Plus, you just didn't know about it and that's no fault of your own. I can't make any promises, but I'm going to try to pull some strings for you and see if they'll let me go back and get it for you under that preferred rate, okay?"\n\nCaller: "Yes please, if you could do that, I would greatly appreciate it."\n\nAgent: "Sure, I'll do everything I can. I'm just going to ask you a couple of quick questions to make sure you qualify for the preferred plan and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
    ],
  },

  "Healthy vs Unhealthy V1": {
    type: "script",
    sections: [
      {
        label: "SETUP",
        text: `Caller: "I'm calling to take out a loan on my policy against my cash value."\n\nAgent: "Okay, I'll be more than happy to help with that. How much are you looking to take out?" (take note of what they need)\n\nCalculate their approximate cash value (DO NOT tell them unless absolutely necessary):\n(Annual Premium) x (# of years – 1 year) x 0.15\n\nExample: If this calculation comes out to about $800, you tell them a range of $600-$800. Under promise and pleasantly surprise them later when you over deliver.\n\n**If they've ever taken a loan, this calculation is not accurate**\n**You must give them a range and not an exact amount**\n\nFind how long they've had the policy, gather info & place on hold.`,
      },
      {
        label: "HOOK",
        text: `Agent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I can absolutely help you with that! When it comes to taking out money from your policy, there are two ways to go about doing so. There is a healthy option and there is an unhealthy option. Did anyone go over that with you?" (pause)\n\nCaller: "No, what does that mean?"\n\nAgent: "You actually called in for the unhealthy option. That is where you can only access a portion of your cash value. You will have to pay the Premium, plus the loan payment, plus interest. I've seen clients' payments go all the way up to __ before. Or the Healthy option is you don't have to pay any of the loan back, no interest, receive ALL of your cash value, and it actually would get you into a higher category for your health through another insurance company we're contracted with _____ (Aflac/Transamerica/Foresters/Senior Life)."`,
      },
      {
        label: "TRANSITION",
        text: `Agent: "So, are you still healthy? (Heart attacks, strokes, cancers, COPD, diabetes...)"\n\nCaller: "No/Yes" (gather health info)\n\nAgent: "So out of these 2 options, which one would you go with?"\n\nCaller: "Oh, the healthy one."\n\nAgent: "That's what I thought. I cannot make any promises, let me go back and see if we are still able to get you this. I'm just going to ask you a couple of quick questions to make sure you still qualify for the healthy option and let me see if I can get that option approved for you."\n\nCaller: "Oh, thank you."\n\n-Roll into Master App-`,
      },
    ],
  },

  "Healthy vs Unhealthy V2": {
    type: "script",
    sections: [
      {
        label: "HOOK",
        text: `Caller: "I'm calling to _____." (write down what they called in for)\n\nAgent: "Sure! I can definitely help you out with that."\n\nFind how long they've had the policy, gather info & place on hold.\n\nAgent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I can absolutely help you with _____ (repeat what they called in for). But I did see something here when I put in your information into the system that caught my attention (pause). Was there a reason you went with the unhealthy option when it comes to taking money from your policy?" (big pause)\n\nCaller: "Unhealthy option? What does that mean?" (Let the customer respond)`,
      },
      {
        label: "UNHEALTHY EXPLANATION",
        text: `Agent: "Well, the unhealthy option is a loan, where you take out only a portion of your cash value. You have 3 payments. You're paying your premiums, plus you're paying monthly installments on the loan, and you're also paying interest on top of that. That's why your premiums increased to $XXX.XX. Also, your death benefit dropped by the amount of money you owe on the loan. I'm assuming you didn't want to jeopardize the payout amount to your family, correct?" (Pause)\n\nCaller: <says their response> (Let the customer respond)\n\nAgent: "That's the unhealthy option, which I'm surprised you went with. But did anyone go over the interest-free, cash surrender option with you?"\n\nCaller: "No."\n\nAgent: "Well, what kind of health issues have you had? I promise I'm asking for a good reason."\n\nCaller: <says their response> (gather/write down health info)\n\nAgent: "So, you haven't had a heart attack, cancer, stroke?" (Pause) "What about COPD or diabetes?"\n\nCaller: "No/Yes" (gather/write down health info)`,
      },
      {
        label: "HEALTHY SOLUTION",
        text: `Agent: "Okay, because getting your interest-free cash value would be considered the healthy option. Had you done that, you would have gotten 100% of your money in your cash value, you would not have had to pay it back and through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life), you would have still gotten to keep your coverage. I'm trying to figure out why this wasn't already done for you." (Pause) (Let the customer react)\n\nCaller: <says their response>\n\nAgent: "So, it sounds like you were healthy enough for that interest-free cash surrender. You just didn't know about it. Obviously, you would have taken advantage of that, correct?"\n\nCaller: "I didn't know that was an option!"\n\nAgent: "Well, it doesn't really seem fair to me that you never knew that was an option for you. So, here is what I'm going to do (pause). I'm going to kill 2 birds with 1 stone. I'm going to help you with _____ (repeat what they called in for), and I can't guarantee anything because this was supposed to have been done for you a while ago, but while I'm in here, I'm going to try to fix this, and see if I can reactivate that healthy option for you, like you should have been on to begin with. And what that would do for you is:\n\n1. Waive any outstanding loan balances owed. It's like loan forgiveness. So, you wouldn't have to pay that loan back.\n2. They'd cut you an interest-free check for the remaining cash value in your policy, which you also would not have to pay back.\n3. Through another insurance company we're contracted with _____ (Aflac/Transamerica/Foresters/Senior Life), you'd get to maintain your permanent coverage." (Pause)\n\nCaller: <says their response> (let the customer react)\n\nAgent: "Okay I'll try to pull some strings for you. I'm just going to ask you a couple of quick questions to make sure you qualify for the healthy option and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
    ],
  },

  "Temporary vs Permanent V1": {
    type: "script",
    sections: [
      {
        label: "HOOK",
        text: `Caller: "I'm calling to ____." (write down what they called in for)\n\nAgent: "Sure! I can definitely help you with that."\n\nGather info & place on hold.\n\nAgent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. So, I can definitely help you with ____ (repeat what they called in for). But I did see something here when I put in your information that caught my attention (pause). When you took out this policy, were you aware that you were set up on a temporary plan?" (big pause)\n\nCaller: "No? What do you mean?"\n\nAgent: "Were you expecting this to last the rest of your life?" (Pause)\n\nCaller: "Well, yes!"`,
      },
      {
        label: "TERM PROBLEM",
        text: `Agent: "So technically they say it lasts to age 95. But term policies are temporary. What they don't tell you is that you haven't built any cash value and within a few years from now, they will hike the price up between $500-$700 per month to renew it. Would that even be affordable for you?" (Pause)\n\nCaller: <says their response> (Let the customer react)\n\nAgent: "Also, they may drop you from the coverage completely if there are changes to your health. You're still healthy, correct?"\n\nCaller: <says their response> (Let the customer react)`,
      },
      {
        label: "PERMANENT FIX",
        text: `Agent: "Okay, well, because you are still young and healthy, a while ago you were supposed to convert this into a permanent policy through another insurance company we're contracted with _____ (Aflac/Transamerica/Foresters/Senior Life), where your price would never increase, and your coverage would never expire. Plus, you'd build cash value. But you missed your chance to do it. I'm trying to figure out why this wasn't done for you already. Did anyone go over this with you?" (pause)\n\nCaller: "I didn't know about it." <Gives their reasons>\n\nAgent: "Gotcha, well, obviously you would have taken advantage of the permanent coverage and cash value build-up, if you had known about it, correct?"\n\nCaller: "Well, yeah!? I had no idea."\n\nAgent: "Well, here's what I'm going to do. I'm going to kill 2 birds with 1 stone. I'm going to help you with _____ (repeat what they called in for). Also, I can't guarantee anything because this was supposed to have been done a while ago. It doesn't really seem fair to me that you just didn't know about it and that's no fault of your own. So while I'm in here, I'm going to try to fix this, and see if I can get you from that temporary coverage, to permanent coverage, like you should have been on. I'm going to try to pull some strings to reactivate this because this should have been done for you already!"\n\nCaller: <says their response> (Let the customer react)\n\nAgent: "I'm just going to ask you a couple of quick questions to make sure you qualify for the permanent coverage and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
      {
        label:
          "HOOK (REITERATE) — Read this before mentioning the price on temp vs perm",
        text: `Agent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding.\n\nSo, as I mentioned before, term policies are temporary coverage. When it expires, you'll lose the coverage, or they'll hike up the price between $500-$700 per month to renew. Typically, term policies are cheaper, for higher coverage amounts. But that's because they are not guaranteed to pay out. In fact, less than 3% of term policies ever pay out to families, unfortunately, because they expire (pause). With this, on the other hand, it's whole life, permanent coverage. Meaning your price will never increase and your coverage will never go away, therefore, it is guaranteed to pay out to your family on the day you pass away." (Optional: Include a 3rd party story)\n\n-NOW move into the 3-Choice Close-`,
      },
    ],
  },

  "Temporary vs Permanent V2": {
    type: "script",
    sections: [
      {
        label: "HOOK",
        text: `Caller: "I'm calling to ____." (write down what they called in for)\n\nAgent: "Sure! I can definitely help you with that."\n\nGather info & place on hold.\n\nAgent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. So, I can definitely help you with ____ (repeat what they called in for). But I did see something here when I put in your information that caught my attention (pause). When you took out this policy, were you aware that you were set up on a temporary plan?" (big pause)\n\nCaller: "No? What do you mean?"\n\nAgent: "Were you expecting this to last the rest of your life?" (Pause)\n\nCaller: "Yes/No"`,
      },
      {
        label: "GROUP POLICY ISSUE",
        text: `Agent: "So, the reason I ask is because your life insurance is attached to your job. That means you'd lose your coverage and have to apply for insurance all over again if you lose your job, quit, or retire. I'm sure you don't plan on not having a job anytime soon, right? But, considering that the price of insurance is based on your age, it can become incredibly pricey later. Also, if you're much older you could have new health conditions that don't allow you to qualify for coverage at that time. You also haven't been building any cash value this whole time. Has anyone explained any of this to you?" (Pause)\n\nCaller: "No, this is the first I'm hearing of it." (Let the customer react)\n\nAgent: "Also, with these group policies, they assume that everyone who signs up is unhealthy and charges everybody the same rate. But you're healthy, correct?"\n\nCaller: <says their response> (gather health info)\n\nAgent: "Have you had cancer, a stroke, or heart attack??" (Pause) "What about COPD or diabetes?" (gather health info)`,
      },
      {
        label: "INDIVIDUAL PERMANENT",
        text: `Agent: "Okay, then you should've had an individual policy. So, because you are still young and healthy, it's showing me that a while ago, you were supposed to convert this into a permanent policy through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life), where your coverage would never expire, so you'd remain covered even when you no longer work there. Also, your price would have been locked in and never increased no matter how old or how sick you got. Plus, you would have been building cash value where you could have pulled out money from your policy if you needed it. But it seems you missed your chance to do it. I'm trying to figure out why this wasn't done for you already. Did anyone go over this with you?" (pause)\n\nCaller: "I didn't know about it." <Gives their reasons>\n\nAgent: "Gotcha, well, you obviously would have taken advantage of the permanent coverage and cash value build-up, had you known about it, correct?"\n\nCaller: "Well, yeah!? I had no idea."\n\nAgent: "Well, here's what I'm going to do. I'm going to kill 2 birds with 1 stone. I'm going to help you with _____ (repeat what they called in for). Also, I can't guarantee anything because this was supposed to have been done for you a while ago. It doesn't really seem fair to me that you just didn't know about it and that's no fault of your own. So, while I'm in here, I'm going to try to fix this, and see if they'll let me go back and get you from that temporary coverage, to permanent coverage, like you should have been on to begin with. I'm going to try to pull some strings to reactivate this because this should have been done for you already!"\n\nCaller: <says their response> (Let the customer react)\n\nAgent: "I'm just going to ask you a couple of quick questions to make sure you qualify for the permanent coverage and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
      {
        label:
          "HOOK (REITERATE) — Read this before mentioning the price on temp vs perm",
        text: `Agent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding.\n\nSo, as I mentioned before, term policies are temporary coverage. When it expires, you'll lose the coverage, or they'll hike up the price between $500-$700 per month to renew. Typically, term policies are cheaper, for higher coverage amounts. But that's because they are not guaranteed to pay out. In fact, less than 3% of term policies ever pay out to families, unfortunately, because they expire (pause). With this, on the other hand, it's whole life, permanent coverage. Meaning your price will never increase and your coverage will never go away, therefore, it is guaranteed to pay out to your family on the day you pass away." (Optional: Include a 3rd party story)\n\n-NOW move into the 3-Choice Close-`,
      },
    ],
  },

  "Standard vs Preferred": {
    type: "script",
    sections: [
      {
        label: "HOOK",
        text: `Caller: "I'm calling to _____." (write down what they called in for)\n\nAgent: "Sure! I can definitely help you out with that."\n\nGather info & place on hold.\n\nAgent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I can definitely help you with _____. (repeat what they called in for) Also, I'm seeing something that I'm a little confused about. (pause) Did you have a major medical issue when you took out this policy?" (pause)\n\nCaller: "What? No? <let them react> Why do you ask?"`,
      },
      {
        label: "STANDARD VS PREFERRED",
        text: `Agent: "Well, the reason I ask is because it appears you've been set up on a standard plan, which is typically for people who are unhealthy. But that's not you, right?" (Pause)\n\nCaller: "No." <Let the customer react>\n\nAgent: "Wow really?!? So, you don't have a history of cancer, stroke, heart attack??" (Pause) "What about COPD or diabetes?"\n\nCaller: "No! I'm healthy!"\n\nAgent: "Okay, that's what I thought. It looks like a while ago someone tried to reach out to you because you should have been set up on the preferred plan. That's for people who are healthy, and it would have given you much more coverage for what you're paying." (Pause)\n\nCaller: <says their response>\n\nAgent: "Yeah, and looks like that preferred plan should have been set up through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life), but you missed your last chance to do it. Why wasn't this done for you already?"\n\nCaller: "I never knew about it. Nobody told me." (gives their reason)\n\nAgent: "Gotcha, okay. Well, it sounds like you were healthy enough for the preferred plan. Obviously, you would have taken advantage of that, correct?"\n\nCaller: "Of course I would have!"\n\nAgent: "Well, this is definitely a problem that needs to be fixed."\n\nCaller: "Well, how can I get this fixed? Is it too late?"\n\nAgent: "Well, here is what I'm going to do, I'm going to kill 2 birds with 1 stone. I'm going to help you _____ (repeat what they called in for). Also, I can't guarantee anything because this was supposed to have been done a while ago and I can't make any promises that this is still available, but while I'm here I'm going to see if they'll let me go back and fix this to get you from that standard plan into the preferred plan like you should have been on to begin with. Okay?"\n\nCaller: <says their response> (let the customer react)\n\nAgent: "Okay I'll try to pull some strings for you. I'm just going to ask you a couple of quick questions to make sure you qualify for the preferred plan and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
    ],
  },

  "Premium Reduction": {
    type: "script",
    sections: [
      {
        label: "HOOK (CANCELLATION STATUS — V1)",
        text: `Caller: "I'm calling to get the status of my cash surrender check."\n\nAgent: "Sure! I'll be more than happy to help you out with that."\n\nGather info & place on hold.\n\nAgent: "Hey, Mr./Mrs. Customer, are you still with me? (Pause) Thank you so much for holding. I can definitely help you find out where your check is at. Now let me ask you this. Are you replacing this policy with another one? (DO NOT PAUSE) The reason I ask is because if you did, your new agent needs to do replacement paperwork and if it's not done, there can be a holdup with releasing your money to you." (Pause)\n\nIF YES:\nAgent: "Alright, well I'd be happy to get that information in here to speed up the process." (Pause) "What company is your new policy with? Verify the coverage. Verify the premium."\nCaller: <Says their response>\nAgent: "Alright, let me notate this for you. Just a moment." (Pause) → "Alright so I'm going to make sure you get this check. But also, I'm seeing something a little concerning about your new coverage." (Pause) → Move to Premium Reduction Hook below.\n\nIF NO:\nAgent: "No worries, I'm going to do everything I can to find out what may be holding it up. By the way, great job on cancelling this. I would too if I were you." → Move to Premium Reduction Hook below.`,
      },
      {
        label: "HOOK (CALLING TO CANCEL — V2)",
        text: `Caller: "I'm calling to cancel my life insurance policy."\n\nAgent: "Sure! I'll be more than happy to help you out with that."\n\nGather info & place on hold.\n\nAgent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I can definitely help you with cancelling this policy (pause). For the notes, I do need to verify the reason for your cancellation, please."\n\nCaller: "I can't afford it anymore, it's too expensive." <explains their reasons>\n\nAgent: "I'm sorry to hear that you're cancelling but I completely understand why you need to cancel. Now, let me ask you this. Are you replacing this policy with another one? (DO NOT PAUSE) The reason I ask is because if you did, your new agent needs to do replacement paperwork and if it's not done, there can be a holdup with releasing any money back to you for this policy." (Pause)\n\nIF YES:\nAgent: "Alright, well I'd be happy to get that information in here to speed up the process. What company is your new policy with? Verify the coverage. Verify the premium."\nCaller: <Says their response>\nAgent: "Alright, let me notate this for you. Just a moment." → "Okay, so I'm definitely going to help you with this cancellation. But also, I noticed something a little concerning about your new coverage." → Move to Premium Reduction Hook below.\n\nIF NO:\nAgent: "Alright, perfect. Then I'll definitely help you out with this cancellation. By the way, great job on cancelling this. I would too if I were you." → Move to Premium Reduction Hook below.`,
      },
      {
        label: "HOOK — PREMIUM REDUCTION (CONTINUED)",
        text: `Agent: "The reason I say that is because based on the information in my system, it appears the policy was issued on a standard plan (pause). Did you have a major medical issue when you took out the policy?" (pause)\n\nCaller: "What? No? <let them react> Why do you ask?"\n\nAgent: "Okay because a standard plan is typically for people who are unhealthy. But that's not you, right?" (Pause)\n\nCaller: "No." <Let the customer react>\n\nAgent: "So, you don't have a history of cancer, stroke, heart attack??" (Pause) "What about COPD or diabetes?"\n\nCaller: "No! I'm healthy!"\n\nAgent: "Okay, that's what I thought. It looks like a while ago someone tried to reach out to you because you should have been set up through another insurance company we're contracted with _____ (Aflac/Transamerica/Foresters/Senior Life), on the preferred plan. That's for people who are healthy, and would have significantly reduced your monthly payment. Why wasn't this done for you already?" (Sound concerned) (Let the customer react)\n\nCaller: "I never knew about it. Nobody told me." (gives their reason)\n\nAgent: "Yeah, because I'm seeing that a whole life policy under today's standard rate is $XXX.XX (what they are paying). But they tried to activate it for you under the preferred rate through _____ (Aflac/Transamerica/Foresters/Senior Life) for only $XX.XX. Did anyone make you aware of this?" (pause)\n\nCaller: "No, this is the first I'm hearing of this!" <let the customer react>\n\nAgent: "Gotcha, okay. Well, obviously if you had known about the preferred plan, you would have taken advantage of that, correct?"\n\nCaller: "Of course I would have!"\n\nAgent: "Well, here is what I'm going to do, I'm going to kill 2 birds with 1 stone. I'm going to help you make sure that this policy is cancelled and that no further premiums come out. Plus, I'll help make sure you get a check for any money owed to you. Also, I can't guarantee anything because this was supposed to have been done a while ago, but while I'm here, I'm going to try to fix this and see if I can get you from that standard plan into the preferred plan like you should have been on to begin with. This should have been done for you already!"\n\nCaller: <says their response> (let the customer react)\n\nAgent: "Okay I'll try to pull some strings for you. I'm just going to ask you a couple of quick questions to make sure you still qualify for the preferred plan and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
    ],
  },

  "Additional Coverage": {
    type: "script",
    sections: [
      {
        label: "SETUP",
        text: `Caller: "I'm calling to _____." (write down what they called in for)\n\nAgent: "Sure! I can definitely help you out with that."\n\nGather info & place on hold.`,
      },
      {
        label: "HOOK — IF THEY HAVE $5K–$10K POLICY",
        text: `Agent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I can definitely help you with _____ (repeat what they called in for). But real quick, verify was this policy intended to cover a cremation?"\n\nIF NO:\nCaller: "No, this was for a burial."\nAgent: "Okay, well that makes sense why they tried to reach out to you. The average cost of a burial today is between $15k-$20k. But it looks like a while ago you were supposed to activate the additional ____ ($5k-$10k) of coverage through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life), to move you up to a burial policy and for inflation protection. They tried to activate it for you at the preferred rate. Why didn't you take advantage of that when you had the chance?"\n\nIF YES:\nCaller: "Yes, this was for a cremation."\nAgent: "Okay, well that makes sense why they tried to reach out to you. The average cost of a cremation today is between $8k-$10k, depending on where you live. But the cost of cremation continues to increase with inflation. And it looks like a while ago you were supposed to activate the additional _____ ($5k-$10k) of coverage through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life), to make sure your policy is protected against inflation and to make sure most of the proceeds go to your beneficiaries. They tried to activate it for you at the preferred rate. Why didn't you take advantage of that when you had the chance?"`,
      },
      {
        label: "HOOK — IF THEY HAVE $11K–$20K POLICY",
        text: `Agent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I can definitely help you with _____ (repeat what they called in for). But real quick, verify, was this policy intended to cover a burial and you're not leaving anything behind for your beneficiaries?"\n\nCaller: "Well it's for a burial, but I'd like to leave something for my beneficiaries."\n\nAgent: "Okay, well that makes sense why they tried to reach out to you. The average cost of a burial is between $15k-$20k and it continues to increase with inflation. But it looks like a while ago you were supposed to activate the additional _____ ($5k-$10k) of coverage through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life), for inflation protection and to make sure you leave behind some money for your beneficiaries. They tried to activate it for you at the preferred rate. Why didn't you take advantage of that when you had the chance?"`,
      },
      {
        label: "HOOK — IF THEY HAVE $20K POLICY OR GREATER",
        text: `Agent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I can definitely help you with (repeat what they called in for). But while I'm in here, I did see something I'm a little confused about (pause). It looks like a while ago, you were supposed to activate the additional _____ ($5k-$10k) of coverage through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life), for inflation protection to cover your final expenses and make sure all the proceeds from your current policy goes to your beneficiary. They tried to activate it for you at the preferred rate. Why didn't you take advantage of that when you had the chance?"`,
      },
      {
        label: "ADDITIONAL COVERAGE (CONTINUED)",
        text: `Caller: States their reason: Didn't know about it.\n\nAgent: "Hmm… that makes sense why it was never accepted or declined." (pause) "Today's standard rate on that coverage is about $XXX.XX. But they tried to activate it for you at the preferred rate for only $XXX.XX. But you said no one reached out to you on that? You just didn't know about it?"\n\nCaller: "Well yes, maybe they reached out, but I just never knew about it."\n\nAgent: "Well, obviously if you would have known about it, you would have taken advantage of that, correct?"\n\nCaller: "Yes of course I would have!"\n\nAgent: "Okay, well here's what I'm going to do (pause). I'm going to kill 2 birds with 1 stone. I'm going to help you with _____ (repeat what they called in for) and while I'm in here, I'm just going to see if they will let me go back and reinstate that preferred rate, because like I said, it was never accepted or declined. Plus, you just didn't know about it and that's no fault of your own. I can't make any promises, but I'm going to try to pull some strings for you and see if they'll let me go back and get it for you under that preferred rate, okay?"\n\nCaller: "Yes please, if you could do that, I would greatly appreciate it."\n\nAgent: "Sure, I'll do everything I can. I'm just going to ask you a couple of quick questions to make sure you qualify for the additional coverage and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
    ],
  },

  "Interest-Free Cash Surrender": {
    type: "script",
    sections: [
      {
        label: "SETUP",
        text: `Caller: "I'm calling to _____." (write down what they called in for)\n\nAgent: "Sure! I can definitely help you out with that."\n\nGather info & place on hold.\n\nCalculate their approximate cash value (DO NOT tell them unless absolutely necessary):\n(Annual Premium) x (# of years – 1 year) x 0.15\n\nExample: If this calculation comes out to about $800, you tell them a range of $600-$800. Under promise and pleasantly surprise them later when you over deliver.\n\n**If they've ever taken a loan before, this calculation is not accurate**`,
      },
      {
        label: "HOOK",
        text: `Agent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I can definitely help you with _____ (repeat what they called in for). However, I'm seeing something in here you might not be aware of." (Pause)\n\nCaller: "Okay, what is it?"\n\nAgent: "Well, based on my system it appears you have a lot of cash value. Do you know what cash value is and how it works?"\n\nCaller: "Yes/No." (Either way, explain)\n\nAgent: "So, I don't know if you were aware, but as you've been putting money into this policy, it hasn't just been covering your final expenses, but it's also been growing for you like a bank account. I'm wondering, did anyone go over how you should've accessed your money, interest-free, and not had to pay it back?" (Pause) (Sound genuinely concerned)\n\nCaller: <Let the customer react and respond/make sure the customer understands what you just said>\n\nAgent: "Another thing I wanted to address with you was; did anyone make you aware that if something happens to you, you would forfeit all this cash value that has built up in your policy to the insurance company?" (Pause) (let the customer react)\n\nCaller: "No… what do you mean?"`,
      },
      {
        label: "HEALTHY ACCESS",
        text: `Agent: "No one made you aware of that?"\n\nCaller: "No, I had no idea!"\n\nAgent: "Did you maybe have any major medical issues?"\n\nCaller: <says their response>\n\nAgent: "Got it. So, you don't have a history of cancer, stroke, heart attack, COPD or diabetes?"\n\nAgent: "Well, _____ (because you're in good health – or – if your only health issue was _____), it looks like a while ago you were actually supposed to take out all of your cash value, interest free, and get your cash value sent to you in a check. Then you would continue your permanent coverage, through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life), but you missed your last chance to do it. I'm trying to figure out why this wasn't done for you already. Did anyone reach out to you to go over this?" (Pause)\n\nCaller: <says their response>\n\nAgent: "Well, obviously if you would have known about it, you would have taken advantage of that, correct?"\n\nCaller: "Well yes, what do I have to do? Is it too late?"\n\nAgent: "Well, here's what I'm going to do (pause). I'm going to kill 2 birds with 1 stone. I'm going to help you with _____ (repeat what they called in for), and while I'm in here, I'm just going to see if they will let me go back and reactivate this for you. It doesn't really seem fair to me that you just didn't know about it and that's no fault of your own. I can't make any promises, but I'm going to try to pull some strings for you and see if they'll let me go back and get this fixed for you, okay?" (Pause)\n\nCaller: "Yes please, if you could do that, I would greatly appreciate it."\n\nAgent: "Sure, I'll do everything I can. I'm just going to ask you a couple of quick questions to make sure you qualify and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
    ],
  },

  "Cash Value Statement": {
    type: "script",
    sections: [
      {
        label: "HOOK",
        text: `Caller: "I'm calling because _____ (Medicaid -or- Housing) needs a copy of my policy/cash value statement."\n\nAgent: "Sure! I can definitely help you out with that."\n\nGather info & place on hold.\n\nAgent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I can definitely help you with that cash value statement. As you know, it's very normal for them to require a copy of your policy. It's because they want to know how much cash value you currently have. They use this cash value against you as a form of income, which they will use to determine your _____ (eligibility for Medicaid -or- monthly rent payment) (pause). Now, I'll be more than happy to help you get this cash value statement sent over. But when I put your information into the system, I saw something that caught my attention." (pause)\n\nCaller: "Okay?? What is it?"`,
      },
      {
        label: "SOLUTION",
        text: `Agent: "Well, it's showing me that someone tried to reach out to you, because a while ago, you were supposed to take out all the cash value interest-free from this policy in a lump-sum check, which you would not have to pay back (pause). That way when you presented your life insurance policy to _____ (Medicaid -or- the leasing office), it would have shown there is zero cash value in the policy. That would have helped you qualify for _____ (maximum benefits with Medicaid -or- lower monthly rent payments). Then, through another insurance company we're contracted with _____ (Aflac/Transamerica/Foresters/Senior Life), you'd still maintain your coverage. It seems you missed your last chance to do it. Why wasn't this done for you already?"\n\nCaller: "No one spoke to me about that. I didn't know about it."\n\nAgent: "Hmm… well you did need to be healthy to qualify for that option. Maybe it's because you had a major medical issue (pause). Do you have a history of heart attack, cancer, stroke, COPD, or diabetes?"\n\nCaller: "No, I'm healthy!"\n\nAgent: "Wow! (sound surprised). Okay, so you are healthy, and you said no one made you aware of this, right?"\n\nCaller: "Yes, I had no idea!"\n\nAgent: "Well, you just didn't know about it. Obviously, you would have taken advantage of that, correct?"\n\nCaller: "Of course I would have!"\n\nAgent: "Okay, well here's what I'm going to do (pause). I'm just going to see if they'll let me go back and reinstate that option for you because you just didn't know about it and that's no fault of your own. I can't guarantee anything because this was supposed to have been done a while ago, but I'm going to try to fix this, and see if I can get you that cash value out of your policy, so that it won't affect _____ (your eligibility for Medicaid -or- your rent payment). Then, I'll help you get that updated cash value statement sent over to them, okay?" (Pause)\n\nCaller: <says their response> (let the customer react)\n\nAgent: "Okay I'll try to pull some strings for you. I'm just going to ask you a couple of quick questions to make sure you qualify for that option and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
    ],
  },

  Consolidation: {
    type: "script",
    sections: [
      {
        label: "HOOK",
        text: `Caller: "I'm calling to _____." (write down what they called in for)\n\nAgent: "Sure! I can definitely help you out with that."\n\nGather info & place on hold.\n\nAgent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I can definitely help you with _____. (repeat what they called in for) Also, I'm seeing something that I'm a little confused about. (pause) Did you have a major medical issue when you took out these policies?" (pause)\n\nCaller: "What? No? <let them react> Why do you ask?"`,
      },
      {
        label: "CONSOLIDATION BENEFIT",
        text: `Agent: "Well, the reason I ask is because typically people are obligated to take multiple policies like this when they are unhealthy. As a result, you end up paying more for your life insurance by paying on multiple policies and it makes filing a claim much more complicated for your family when you pass." (Pause) "I'm assuming you'd want the process of your loved ones getting this money to be as smooth as possible, correct?"\n\nCaller: "Well yes, of course!" (Let the customer react)\n\nAgent: "Well, do you have a history of cancer, stroke, heart attack, (Pause) What about COPD or diabetes?"\n\nCaller: "No! I'm healthy!"\n\nAgent: "Okay, that's what I thought. It looks like a while ago someone tried to reach out to you because you were supposed to consolidate these policies into one policy under the preferred plan, set up through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life). That's for people who are healthy and would have given you one policy with more coverage for what you're paying or given you the same amount of coverage at a lower rate. Plus, you would have prevented a lot of stress on your family since they would only have to file one claim instead of multiple. Did anyone speak to anyone about this?" (Pause)\n\nCaller: "No!" (Let the customer react)\n\nAgent: "Gotcha, okay. Well, it sounds like you were healthy enough for that consolidation. You just didn't know about it. Obviously, you would have taken advantage of that, correct?"\n\nCaller: "Of course I would have!"\n\nAgent: "Well, this definitely needs to be fixed."\n\nCaller: "Well, how can I get this fixed? Is it too late?"\n\nAgent: "Well, here is what I'm going to do, I'm going to kill 2 birds with 1 stone. I'm going to help you _____ (repeat what they called in for). Also, I can't guarantee anything because this was supposed to have been done for you a while ago and I can't make any promises that this is still available, but while I'm here I'm going to try to fix this and see if I can reactivate that consolidation for you, okay?" (Pause)\n\nCaller: "Okay, thank you."\n\nAgent: "Okay I'll try to pull some strings for you. I'm just going to ask you a couple of quick questions to make sure you qualify for that consolidation and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
    ],
  },

  "Extension of Coverage": {
    type: "script",
    sections: [
      {
        label: "HOOK",
        text: `Caller: "My _____ (loved one) has a policy I need some help with, but I don't have any policy information."\n\nAgent: "Sure, I can definitely help you out with that. Go ahead and verify your _____ (loved-one's) first, last name, and date of birth (pause, write it down). Now go ahead and verify your first, last name, and date of birth as well, please." (write it down, then place on hold)\n\nAgent: "Hey, I'm back, are you still with me?"\n\nCaller: "Yes, I'm still here."\n\nAgent: "Thanks so much for holding. I can definitely help you with this _____ (repeat what they called in for). But while I have you, _____ (Mr./Mrs. Customer name), I just want to ask, because something seems a little strange to me." (Pause)\n\nCaller: "Okay, what is it?"\n\nAgent: "Well, it seems as though _____ (your loved-one) caused an extension of coverage to become available to you, which would entitle you to a preferred plan through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life). It's like a friend's and family. That would make sure that your family doesn't have to come out of pocket for your final expenses if something happened to you, God forbid. The same way _____ (loved one's name) set this policy up for their loved-ones like yourself, this is set up so you can also leave some money behind for your loved ones as well, but at a lower rate. Is there any reason this hasn't been activated for you already? Did anyone go over this with you?"\n\nCaller: "No, this is the first time I'm hearing of it." (Skip to "Okay well I want to make sure…" below)\n-Or-\nCaller: "Well, I already have insurance, so I'm good."\n\nAgent: "Okay, that's great that you are already covered! Well, this was a reduced rate that's been made available to you. Let me ask you this, how much are you paying for that?" (Let them respond, gather info) "How much coverage is that for?" (Let them respond, gather info)`,
      },
      {
        label: "REDUCED RATE CLOSE",
        text: `Agent: "Okay well I want to make sure you're taking advantage of everything that's been made available for you and your family. I'm trying to figure out why this wasn't done for you already. Did you have a major medical issue by chance?" (Pause)\n\nCaller: "No! I'm healthy!"\n\nAgent: "So, you don't have a history of cancer, stroke, heart attack??" (Pause) "What about COPD or diabetes?"\n\nCaller: (gather health info)\n\nAgent: "Well, it sounds like you would have been eligible for that extension of coverage. But you said no one reached out to you about this? You just didn't know about it?"\n\nCaller: "No, I had no idea!"\n\nAgent: "Well, obviously you would have taken advantage of that, correct?"\n\nCaller: "Yes, of course!"\n\nAgent: "Well, it looks like you missed your chance to activate that because this was supposed to have been done for you a while ago, but no one explained it to you and that's no fault of your own. So, here's what I'm going to do. I'm going to kill 2 birds with 1 stone. I'm going to help you _____ (repeat what they called in for), and while I'm in here, I'm going to see if they'll let me go back and fix this for you. I'll try to pull some strings and see if they'll let me get this extension of coverage reactivated for you as well. Okay?"\n\nCaller: "Okay."\n\nAgent: "I'll just have to ask you a few quick questions to make sure you still qualify and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
    ],
  },

  "Death Claim": {
    type: "script",
    sections: [
      {
        label: "OPENING — WITH EMPATHY",
        text: `Caller: "My _____ (person) just passed away and I need some help with a policy they had." -or- "I found this policy on my (person) who passed and wanted to know if it is still valid?"\n\nAgent: "Sure, I can definitely help you out with that. Go ahead and verify your _____ (loved-one's) first, last name, and date of birth (pause, write it down). I'm assuming you are the beneficiary of the policy so go ahead and verify your first, last name, and date of birth as well, please." (write it down, then place on hold)\n\nAgent: "Hey, I'm back, are you still with me?"\n\nCaller: "Yes, I'm still here."\n\nAgent: "Thanks so much for holding. First of all, I send my deepest condolences to you and your family during this time." (Pause)\n\nCaller: "Thank you."\n\nAgent: "I can definitely help you with this claim. Do you have the death certificate already by chance?" (Pause) "Great! Just to give you an idea of what the process looks like, we cannot file a claim until we have that. But you can send it in by email, fax, or mail. From there it's pretty straightforward. They process the request, may ask you for some additional information, but after that, they'll mail a check." (Pause)\n\nCaller: "Okay" (Let the customer respond)`,
      },
      {
        label: "UNCLAIMED BENEFITS",
        text: `Agent: "Now, I'm going to help you get all the information you need for this claim. But while I have you, _____ (Mr./Mrs. Customer name), I just want to ask, because something that seems a little strange to me." (Pause)\n\nCaller: "Okay, what is it?"\n\nAgent: "Well, it seems there are unclaimed benefits, not just in the form of the proceeds that would be sent as a check, but also it seems as though _____ (your loved-one) caused an extension of coverage to become available to you, which would entitle you to preferred rates through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life). It's like a friend's and family. This would make sure that your family doesn't have to come out of pocket on any of your final expenses if something happened to you, God forbid. The same way _____ (loved one's name) left some money behind for you, this is set up so you can also leave some money behind for your loved ones as well, on top of getting the proceeds from _____ (his/her) policy. Is there any reason this hasn't been activated for you already? Did anyone go over this with you?"\n\nCaller: "No, this is the first time I'm hearing of it." (Skip to "Okay well I want to make sure…" below)\n-Or-\nCaller: "Well, I already have insurance, so I'm good."\nAgent: "Okay, that's great that you are already covered! Well, this was a reduced rate that's been made available to you. Let me ask you this, how much are you paying for that?" (Let them respond, gather info) "How much coverage is that for?" (Let them respond, gather info)\n\nAgent: "Okay well I want to make sure you're taking advantage of everything that's been made available for you. You're in a much better position, in THIS moment, than you might be in 5 months, or even 5 years. I'd encourage you to take advantage of this, for you and your family. Now, this was supposed to have been done a while ago, but no one explained it to you and that's no fault of your own. So, I'm going to try to pull some strings and see if they'll let me get this reactivated for you, before the claim is finalized and it goes away. Then, of course, I'll help you finalize the claim, okay?"\n\nCaller: "Okay."\n\nAgent: "I'll just have to ask you a few quick questions to make sure you still qualify and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
      {
        label: "BUTTON UP (DEATH CLAIM)",
        text: `Agent: "Congratulations, you got approved! And I'm still going to help you with your _____'s (family member's) claim. For _____ (beneficiary name), we got ___ (40k) in coverage and it includes accidental and living benefits for you."\n\n• If they ask about living benefits, explain. If not, move on.\n*Don't overwhelm the customer by focusing on benefits of their policy. Instead, start focusing on the death claim.*\n\nAgent: "You are also going to get a packet in the mail within the next 1-2 weeks, if you don't receive that one I'm going to give you my direct number." (give name and number)\n\nAgent: "Now to finalize the claim, I'll need to get you connected directly with the claims department. They're going to send you the form you need to fill out and send back with the death certificate attached. Then they'll take over from there. Do you have a pen and paper?"\n\nCaller: "yes/no"\n\nAgent: "Okay well let's go ahead and get this process started. You'll want to start by calling this number to the claims department directly." (Provide carrier's number)\n\n**Pro Tip: Call the carrier's claims department with them, this helps build even more rapport as their agent and helps the deal stick. They'll be less likely to ever cancel since you went the extra mile to help.**`,
      },
    ],
  },

  "Non-Life Insurance Calls": {
    type: "script",
    sections: [
      {
        label: "REDIRECT",
        text: `Caller: "I'm calling to _____." (pull out money against my 401k)\n\nAgent: "Sure! I can definitely help you out with that."\n\nGather info & place on hold.\n\nAgent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I can definitely help you with _____ (repeat what they called in for). Now before we do anything with that, I see here that sometime last year you were supposed to activate the life and accidental coverage that would coincide with your _____ (401k). It would pay out ___ (50k), that's ___ (25k) whole life, plus ___ (25k) accidental, in the event you were to pass away, and also pay out a lump sum directly to you in the event you came down with an illness or became dismembered. They tried to activate it for you at the preferred rate through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life). I'm trying to figure out why this wasn't done for you already. Did you maybe have a major medical issue?" (pause)\n\nCaller: "I didn't know about it."\n\nAgent: "Wait, so no one reached out to you about this?"\n\nCaller: "No, this is the first time I'm hearing this."\n\nAgent: "Well, obviously if you would have known, you would have taken advantage of that, correct?"\n\nCaller: "Yes of course I would have!"`,
      },
      {
        label: "BRIDGE BACK",
        text: `Agent: "Okay, well here's what I'm going to do (pause). I'm going to kill 2 birds with 1 stone. I'm going to help you with (repeat what they called in for) and while I'm in here, I'm just going to see if they will let me go back and reinstate that preferred rate, because like I said, it was never accepted or declined. Plus, you just didn't know about it and that's no fault of your own. I can't make any promises, but I'm going to try to pull some strings for you and see if they'll let me go back and get it for you under that preferred rate, okay?" (Pause)\n\nCaller: "Yes please, if you could do that, I would greatly appreciate it."\n\nAgent: "Sure, I'll do everything I can. I'm just going to ask you a couple of quick questions to make sure you qualify for the additional coverage and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
    ],
  },

  "Living Benefits / FREE Option": {
    type: "script",
    sections: [
      {
        label: "LIVING BENEFITS INTRO",
        text: `Calculate ROP: (annual premium for 100k x 30 years)\n\nAgent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding. I can definitely help you with _____ (repeat what they called in for). Now before we do anything with that, I see here that sometime within the last year you were supposed to activate your Living Benefits through another insurance company we're contracted with, _____ (Aflac/Transamerica/Foresters/Senior Life), that would coincide with your _____ (Auto Insurance). It would pay out ___ ($100k) in the event you passed away, or pay out a lump sum directly to you in the event you came down with an illness or became critically injured or dismembered in an accident. It seems they tried to activate it for you at the preferred rate. Why wasn't this done for you already?" (pause)\n\nCaller: "I don't know, you tell me." <says their reason>\n\nAgent: "Well, it shows that it was never accepted. But, most people do, because say if you don't have to use this coverage in the next 30 years, you would get 100% of the money you pay into the policy, back to you tax free. Which would be a lump sum of $_____ (annual premium x 30 years). This was supposed to have been activated a while ago. Did anybody go over this with you?" (pause)\n\nCaller: <says their response> (let the customer react)`,
      },
      {
        label: "THE FREE OPTION CLOSE",
        text: `Agent: "If you knew, obviously you would have taken advantage of that, correct?"\n\nCaller: "Yes! Of course."\n\nAgent: "Okay so, here's what I'm going to do (pause). I'm going to kill 2 birds with 1 stone. I'm going to help you with _____ (repeat what they called in for) and while I'm in here, I'm just going to see if they will let me go back and reactivate this for you on that preferred rate. It doesn't seem fair to me that you just didn't know about it and that's no fault of your own. I can't make any promises, because this was supposed to have been done for you a while ago, but I'm going to try to pull some strings for you and see if they'll let me go back and get that reactivated for you, okay?"\n\nCaller: "Okay"\n\nAgent: "Alright, I'm just going to ask you a couple of quick questions to make sure you qualify for the preferred plan and to make sure we have the most up to date and accurate information."\n\n-Roll into Master App-`,
      },
    ],
  },

  "Gathering Beneficiary Info": {
    type: "tool",
    sections: [
      {
        label: "TRANSITION",
        text: `Agent: "I want to make sure there are no discrepancies in your policy. Go ahead and verify the spelling of your beneficiary's name. The spelling please, because it's very important we have the spelling correct."\n\nCaller: <Spells beneficiary name>\n\nAgent: "Thank you. Verify their relationship to you."\n\nCaller: "That's my _____ (family member)."\n\nAgent: "Would they be receiving 100% of the proceeds?"\n\nCaller: "Yes." -or- "No, I'd like it to be split with _____ (additional beneficiary)."\n\nAgent: (Repeat this process for any additional beneficiaries)\nAgent: (Verify/Confirm other beneficiary information required by the app)`,
      },
    ],
  },

  "Say This BEFORE Your 3-Choice Close": {
    type: "tool",
    sections: [
      {
        label: "THE BRIDGE",
        text: `Agent: "Alright, Mr./Mrs. Customer, so what I'm going to do is get with the underwriters. I'm going to vouch for you because you just didn't know about this and that's no fault of your own. Plus, this should have been done for you a while ago. So, I'm going to place you on a brief hold while I try to pull some strings to see if they'll let me go back and get this fixed for you. I'll be right back on the line."\n\nPlace the customer on hold & gather your options for 3-Choice close:\n• Preferred Rates: Located within the application (this is what the client qualified for).\n• Standard Rates: Located at the bottom of Insurance Toolkits.\n\nIf you did NOT pitch temp vs perm → Move into the 3 Choice Close.\n\nIf you pitched temp vs perm → See "Say This BEFORE Your 3-Choice Close (Term vs Perm)" script.`,
      },
    ],
  },

  "Say This BEFORE Your 3-Choice Close (Term vs Perm)": {
    type: "tool",
    sections: [
      {
        label: "TERM VS PERM INTRO",
        text: `*Note: Going over price on temp vs perm*\nReiterate what term vs perm is again, to help them understand what we are doing and to build value. If you tell them flat out the price is increasing, to go from 200k to 80k total coverage, they will shut down and hang up, so you must re-pitch to help them understand why and how we are fixing their policy.\n\nAgent: "Alright, Mr./Mrs. Customer, so what I'm going to do is get with the underwriters. I'm going to vouch for you because you just didn't know about this and that's no fault of your own. Plus, this should have been done for you a while ago. So, I'm going to place you on a brief hold while I try to pull some strings to see if they'll let me go back and get this fixed for you. I'll be right back on the line."\n\nPlace the customer on hold & gather your options for 3-Choice close:\n• Preferred Rates: Located within the application (this is what the client qualified for).\n• Standard Rates: Located at the bottom of Insurance Toolkits.`,
      },
      {
        label: "REITERATE",
        text: `Agent: "Hey, Mr./Mrs. Customer, are you still with me? (pause) Thank you so much for holding.\n\nSo, as I mentioned before, term policies are temporary coverage. When it expires, you'll lose the coverage, or they'll hike up the price between $500-$700 per month to renew. Typically, term policies are cheaper, for higher coverage amounts. But that's because they are not guaranteed to pay out. In fact, less than 3% of term policies ever pay out to families, unfortunately, because they expire (pause). With this, on the other hand, it's whole life, permanent coverage. Meaning your price will never increase and your coverage will never go away, therefore, it is guaranteed to pay out to your family on the day you pass away." (Optional: Include a 3rd party story)\n\n-NOW move into the 3-Choice Close-`,
      },
    ],
  },

  "Say This BEFORE Your 3-Choice Close (UL to WL)": {
    type: "tool",
    sections: [
      {
        label: "UL PROBLEM",
        text: `Before we look at options, I want to flag something about your current universal life policy. UL policies are interest-rate sensitive — as rates dropped, your cash value has likely been eroding to pay premiums. A whole life policy is guaranteed — fixed premium, fixed death benefit, growing cash value. I want to show you how we can secure your coverage before the UL lapses.`,
      },
    ],
  },

  "3 Choice Close": {
    type: "tool",
    sections: [
      {
        label: "OPENING",
        text: `Agent: "Alright, Mr./Mrs. Customer, so I got with the underwriter, and I am getting the initial green light to get you on that (preferred plan/healthy option/permanent coverage/additional coverage). Now that's because of your good health, so congratulations on taking such good care of yourself." (Pause) "Now back when this was supposed to have been done for you, you had a few different options to choose from."`,
      },
      {
        label: "OPTION A (MAX)",
        text: `"1. For compliance, I want to make sure you know all the options made available to you. With maxed-out coverage, you could have gotten ___ ($40k) of whole life coverage plus ___ ($40k) accidental, for a total of ___ ($80k) of coverage. Included in your premium are _____ (EXPLAIN ANY ADDITIONAL BENEFITS, i.e. Are you familiar with living benefits? Let me explain…). Today's standard rate on that coverage is $XXX.XX. But they tried to activate it for you under a preferred rate for only $XXX.XX." (Pause & let customer react)\n\nCaller: "Okay, let's do it!" (stop 3-choice close)\nAgent: "Okay, that's a great choice!" – or –\nCaller: "No that's too much!"\nAgent: "No worries! Like I said, you don't have to go with the maximum option."`,
      },
      {
        label: "OPTION B (MID)",
        text: `"2. I'm also seeing you could have gotten ___ $30k of whole life coverage plus ___ ($30k) accidental, for a total of ___ ($60k) of coverage. That also includes _____ (additional benefits, i.e. living benefits). Today's standard rate on that is $XXX.XX. But they tried to activate it for you under a preferred rate for only $XXX.XX."`,
      },
      {
        label: "OPTION C (MIN)",
        text: `"3. And the other option you had, you could have gotten ___ ($20k) of whole life coverage plus ___ ($20k) accidental, for a total of ___ ($40k) of coverage. Plus, the _____ (additional benefits, i.e. living benefits), of course. Today's standard rate on that is $XXX.XX. But under that preferred rate it was only $XXX.XX. Out of those options, which one would you have chosen?"\n\nCaller: "The second one!"\nAgent: "Okay, that's a great choice!"`,
      },
    ],
  },

  "Gathering Banking Info": {
    type: "tool",
    sections: [
      {
        label: "TRANSITION",
        text: `Agent: "Now, this coverage has no waiting period. So, you don't have to wait 2 years or anything like that. This coverage goes into effect the date of your first payment. When would you like this to go into effect?"\n\nCaller: <Says the date they would like the premium to draft>\n\nAgent: "Got it. So, the first payment will draft on _____ (repeat the date), and it will recur on the _____ of every month moving forward. Is that okay?"\n\nCaller: "Yes, that's fine."\n\nSay this next part, unless they called to get a quote or to update banking information:\n\nAgent: "Since we are obviously getting you better coverage, and we are adjusting your monthly premium, I will need to re-verify the banking information on file for you. Please confirm who you do your banking with."\n\nCaller: <Says the name of their bank>\n\nAgent: "Alright, and did you open that account there in _____?" (State they are in)\n\nCaller: <Tells you where they opened their bank account>\n\nNow look up on Google: "<Name of Bank> <State> Routing Number"`,
      },
      {
        label: "ROUTING & ACCOUNT",
        text: `Agent: "I'm going to verify the routing number I have on file for you, do you have that in front of you to confirm this is correct?"\n\nCaller: <Looks up their banking information> "Go ahead."\n\nAgent: "The routing number I have on file for you is _____, (routing number) is that correct?"\n\nCaller: "Yes, that's correct."\n\nAgent: "Alright, and whenever you're ready, go ahead and verify the account number please."\n\nCaller: "Alright, the account number is _____."\n\nAgent: "Thank you, give me just a moment while I set this up for you."`,
      },
    ],
  },

  "Additional Notes": {
    type: "tool",
    sections: [
      {
        label: "LANGUAGE & APPROACH NOTES",
        text: `• Use words like: Verify and Confirm. Leave out "Can you"\n• Average Funeral Costs:\n  - Cost of cremation: $8K-$10K\n  - Cost of burial: $15K-$20K\n  - Repatriation of Remains (transportation of a cadaver/for example a hearse): $15K-$20K\n  - Avg. inflation rate is 2.5%\n• Various Scenarios, Similar Approach: Despite all the scenarios you might encounter. The approach is similar each time:\n  1. Take the necessary info. Place every caller on hold, formally.\n  2. Come back from hold sounding confused because you "noticed" a missed opportunity.\n  3. Ask them why they never took advantage of it.\n  4. Lead into trying to "reactivate" that missed opportunity.`,
      },
      {
        label: "SITUATIONAL NOTES",
        text: `• Cancellations (someone calling in to cancel):\n  - Get on their side: "Great job on canceling that, I would cancel that too if I were you."\n  - If term policy: "I'm assuming they told you that you wouldn't be accumulating any cash value."\n\n• If the customer mentions they have a trusted agent:\n  - "They're a captive agent, meaning they can only offer one rating, they don't have access to all the rates that I'm able to see here."\n\n• Lapse Policy:\n  - "Based on the information you gave and the system, it's been over 60 days, which puts it in lapse status. It's not giving me the reason why that happened; however, we should have a way to fix it."\n\n• Asking Price During Pitch:\n  - If a customer asks the price of a preferred/permanent/discounted plan during pitch/before approval: "Well, it just depends on what you qualify for. Are you still healthy?" (Ask main 5 health questions) then roll into app.\n\n• If your client misses a payment, call them and say:\n  - "Good morning/Afternoon, Mr./Mrs. _____. This is _____, your personal life insurance broker calling you because I received notification from the company about your life insurance policy. It looks like they were unable to draft your premium this time around. I just wanted to make sure you were aware, so that your policy doesn't lapse and so you don't lose your coverage. I'm not sure why that happened but it's a quick and easy fix." (If leaving a voicemail, provide them your call-back details to get it fixed. If they answered, call the carrier with them to get it fixed.)`,
      },
      {
        label: "TEXT MESSAGE/EMAIL CODE",
        text: `"You're going to receive a text message in a couple seconds. It's just to verify that you are the person you say you are, and to allow us to run a quick medical check to make sure you qualify for that (preferred plan/healthy option/permanent coverage/additional coverage). The message is going to come from (COMPANY NAME) and it will have a 6-digit code. I just need you to read that code back to me please."`,
      },
      {
        label: "MASTER APP / WHEN IN THE APPLICATION",
        text: `1. "Go ahead and verify the spelling of your first and last name."\n2. "Go ahead and verify your current height and weight" (refer to the applicable height & weight chart)\n   • If it's a woman: to create banter you say, for example: "My mother taught me to not ask a woman, however it's just one of those things I have to ask" (makes them laugh)\n3. "Go ahead and confirm your current street address"\n   • After this question, this is a great opportunity to create connection/common ground.\n4. "Just out of curiosity, were you born and raised there in _____ (state)? I've never been there before, what's it like?"\n5. "Verify your email address."\n6. "The number you're calling from, _____ (read their number from RingCentral), is that still your cell phone number?"\n7. "Now I need to update your medical record and history, please confirm your social." (Immediately ask next question)\n8. "You're not a smoker, are you?"\n9. Health Questions (in bold): "Now I need to ask you a few health questions to let them know that you do qualify for this. I'm certain you're healthy, but for compliance they require me to ask these questions, so just bear with me please."\n\nHEALTH ROUTING:\n• Any COPD, Emphysema, or Asthma?\n  - "Do you use a nebulizer, inhaler, or oxygen to assist with breathing?"\n  - COPD/Emphysema: Transamerica, Royal Neighbors (unless smoker)\n  - Oxygen: Transamerica or Corebridge Guaranteed Issue\n  - Asthma (inhaler only): Any Carrier preferred except Aflac/AHL/Aetna\n\n• Any Diabetes or Cancer?\n  - If Diabetes: "Do you take insulin (injection) or metformin (pills)? Have you ever had any complications from your diabetes, like neuropathy, retinopathy, or anything like that? Have you ever been prescribed Gabapentin?"\n  - Insulin (no complications): Any carrier except Mutual of Omaha or Liberty Bankers or Combined\n  - Metformin (no complications): Any carrier\n  - Gabapentin: Senior Life (less than 2 medications for diabetes), TransAmerica, Royal Neighbors (no complications)\n  - Complications: Transamerica or Corebridge Guaranteed Issue\n  - If Cancer: "What kind of cancer? Have you had multiple occurrences of the same or different cancer? How long have you been cancer free for? Are you currently receiving treatment or medication for it?"\n  - Basal cell or squamous: Any Carrier\n  - Treatment over 5 years: Any Carrier, except Senior Life\n  - Treatment over 2 years ago: Aflac/AHL/Aetna, SBLI, Transamerica Standard\n  - Treatment within 2 years: Corebridge SIWL (stage 1/2), or Corebridge Graded/Guaranteed Issue\n  - Single Occurrence: CICA Standard\n  - Multiple Occurrences: Corebridge Guaranteed Issue\n  - Active Cancer/Treatment: Corebridge Guaranteed Issue\n\n• Any Kidney or Liver Issues?\n  - If Kidney: "Do you have kidney disease, insufficiency, or failure? Are you currently on dialysis?"\n  - Kidney Disease: TransAmerica standard, Foresters Planright standard\n  - Dialysis: Corebridge Guaranteed Issue\n  - If Liver: "Is it cirrhosis of the liver?"\n  - Liver issues: Corebridge Guaranteed Issue\n\n• Any Heart Attacks, Strokes, Stents, Seizures or Bypasses?\n  - If any of these: "How long ago was your _____ (Heart Attack, Stroke, Stent Placement)?"\n  - Stroke:\n    Over 2 years: Aflac/AHL/Aetna, TransAmerica, Royal Neighbors, Foresters Planright\n    1-2 years: Royal Neighbors, Aflac/AHL/Aetna Standard, TransAmerica Standard\n    Under 2 years: Corebridge Guaranteed Issue\n  - Heart Attack:\n    Over 2 years: Royal Neighbors, TransAmerica, Aflac/AHL/Aetna\n    1-2 years: TransAmerica, Aflac/AHL/Aetna Standard\n    Under 2 years: TransAmerica, Corebridge Guaranteed Issue\n  - Stents: Any Carrier except Mutual of Omaha & Foresters\n\n• Any Congestive Heart Failure, Lupus, Multiple Sclerosis (MS), Parkinson's, or Lou Gherig's (ALS)?\n  - Congestive Heart Failure: TransAmerica, Corebridge Guaranteed Issue\n  - Lou Gherig's (ALS): Corebridge Guaranteed Issue\n  - Lupus (SLE): Royal Neighbors, TransAmerica, Foresters Planright Standard\n  - Multiple Sclerosis (MS): Foresters Planright, Royal Neighbors, TransAmerica, Aflac/AHL/Aetna\n  - Parkinson's: Royal Neighbors, SBLI, TransAmerica, Aflac/AHL/Aetna Standard, Foresters Planright Standard (if they are able to perform activities of daily living)\n\n• Any Alzheimer's, Dementia, Wheelchair or Walker (Confinement/Dependency)?\n  - Alzheimer's/Dementia: Corebridge Guaranteed Issue\n  - Wheelchair or Walker confinements (except occasional use): TransAmerica, Corebridge Guaranteed Issue\n  Agent: "Do you have a condition that requires you to use of your wheelchair/scooter/walker?" (uncover additional health info)\n\n-Check the health grid and UW Guides to determine which app to start-\n-Now start an application-\n**If you're still unsure of which carrier to write with, ask a leader or trainer. We are here to help.**`,
      },
    ],
  },

  "The Button Up": {
    type: "tool",
    sections: [
      {
        label: "CONFIRMATION",
        text: `Agent: "Okay Mr./Mrs. Customer, before I let you go, I'm going to go over a couple of things. First of all, I want to congratulate you because you have been approved! When you first called in you had ___ ($20k) of coverage on a _____ (standard plan/temporary plan). Now moving forward, we were able to get you approved for that preferred plan and you now have a total of ___ ($80k) of coverage, which includes accidental, _____ (living benefits, funeral concierge, etc.), and accumulates cash value, which is a percentage of every payment that you make and goes into a separate account for you, called your cash value where you can pull out money against it. We got you all these great benefits under the preferred rating, which is THE best rating you can get in the life insurance industry, because of your good health. So, congrats on taking good care of yourself!" (pause)\n\n"With that being said, you never want to lose this policy or let it lapse because you will never be able to get it back again. You are also going to get a packet in the mail within the next 1-2 weeks of your first payment. It's going to say _____ (COMPANY NAME) on it. That's the underwriter that is picking you up on that _____ (preferred plan/permanent coverage/healthy option). You can also access or service your policy details online by registering on the customer portal. Would you like me to text you the link to that site? Either way, you'll get a physical, hard copy in the mail. If you don't receive that one, I'm going to give you my direct line, because I want to make sure you get those documents." (give name and number)\n\n"Now, I am your agent who's directly attached to this policy, so if you ever need anything regarding your life insurance, you now have a direct point of contact. I am your personal life insurance broker and I'm here for you. I really appreciate you placing your trust in me today. I'm also giving you my number because it looks like your beneficiary, _____ (beneficiary's name) is entitled to a free policy review and consultation of their insurance as well. As a broker for the state, I have special access to see past offers, which allows me to get people the right coverage when others can't. Also, if you have family members, close friends, or anyone else who might benefit from the same type of help I provided for you today, feel free to give them my number too. Just let them know that if I don't answer right away, it's because I'm helping another customer. But if they leave me a message or send a quick text, I'll usually get back the same day."`,
      },
      {
        label: "CASH SURRENDER OLD POLICY",
        text: `Agent: "The very last step, Mr./Mrs. Customer, because I want to make sure you don't get double-billed, we're going to get in touch with the billing department so they can close out your standard policy."\n\nIf they've had a WL/UL policy for over 1 year:\n"I want you to write this down Mr./Mrs. Customer, you need to write down the phrase 'cash surrender' — this will force them to kick out any money that they might owe you. I would tell them for you, but they need your verbal authorization as the policy owner to complete this. Now keep in mind you will be speaking to billing/retention. They don't like to cancel out their policies, because they are a business at the end of the day. They are going to try to retain your business. If they give you any trouble or ask why, just let them know it's for personal reasons. That will save you from an hour-long conversation of them trying to keep you on a plan that is no good for you! I'm just being honest. But if they still give you any trouble past that, you have my support, and I've got your back."`,
      },
    ],
  },

  "Objection Handling": {
    type: "objection",
    sections: [
      {
        label: "KEY PRINCIPLES",
        text: `• The key to handling objections is to overcome the objection before the customer objects.\n• If the customer objects, you must respond quickly, without hesitation or apprehension.\n• Learn responses to common objections to prepare yourself to respond quickly and confidently.`,
      },
      {
        label: "I NEED TO THINK ABOUT IT",
        text: `"I completely understand — this is an important decision. Can I ask, is it the coverage amount or the monthly investment that you're unsure about? Because if it's the budget, I have a couple of options that might work better for you."`,
      },
      {
        label: "I NEED TO TALK TO MY SPOUSE",
        text: `"Absolutely, that makes total sense. Is your spouse available right now? Because I want to make sure they have the same information you do — that way you're both making the decision together with the full picture."`,
      },
      {
        label: "I CAN'T AFFORD IT",
        text: `"I hear you, and I appreciate you being upfront. What if we looked at the smallest option — some coverage is always better than none, and we can always increase it later when the timing is better for you."`,
      },
    ],
  },

  // ── NEW: Inline drawer content for AI Script module tabs ──
  "Master App": {
    type: "tool",
    sections: [
      {
        label: "WHEN IN THE APPLICATION",
        text: `1. "Go ahead and verify the spelling of your first and last name."\n2. "Go ahead and verify your current height and weight" (refer to the applicable height & weight chart)\n   • If it's a woman: to create banter you say, for example: "My mother taught me to not ask a woman, however it's just one of those things I have to ask" (makes them laugh)\n3. "Go ahead and confirm your current street address"\n   • After this question, this is a great opportunity to create connection/common ground.\n4. "Just out of curiosity, were you born and raised there in _____ (state)? I've never been there before, what's it like?"\n5. "Verify your email address."\n6. "The number you're calling from, _____ (read their number from RingCentral), is that still your cell phone number?"\n7. "Now I need to update your medical record and history, please confirm your social." (Immediately ask next question)\n8. "You're not a smoker, are you?"\n9. Health Questions (in bold): "Now I need to ask you a few health questions to let them know that you do qualify for this. I'm certain you're healthy, but for compliance they require me to ask these questions, so just bear with me please."`,
      },
      {
        label: "HEALTH ROUTING — COPD / EMPHYSEMA / ASTHMA",
        text: `• Any COPD, Emphysema, or Asthma?\n  - "Do you use a nebulizer, inhaler, or oxygen to assist with breathing?"\n  - COPD/Emphysema: Transamerica, Royal Neighbors (unless smoker)\n  - Oxygen: Transamerica or Corebridge Guaranteed Issue\n  - Asthma (inhaler only): Any Carrier preferred except Aflac/AHL/Aetna`,
      },
      {
        label: "HEALTH ROUTING — DIABETES / CANCER",
        text: `• Any Diabetes or Cancer?\n  - If Diabetes: "Do you take insulin (injection) or metformin (pills)? Have you ever had any complications from your diabetes, like neuropathy, retinopathy, or anything like that? Have you ever been prescribed Gabapentin?"\n  - Insulin (no complications): Any carrier except Mutual of Omaha or Liberty Bankers or Combined\n  - Metformin (no complications): Any carrier\n  - Gabapentin: Senior Life (less than 2 medications for diabetes), TransAmerica, Royal Neighbors (no complications)\n  - Complications: Transamerica or Corebridge Guaranteed Issue\n\n  - If Cancer: "What kind of cancer? Have you had multiple occurrences of the same or different cancer? How long have you been cancer free for? Are you currently receiving treatment or medication for it?"\n  - Basal cell or squamous: Any Carrier\n  - Treatment over 5 years: Any Carrier, except Senior Life\n  - Treatment over 2 years ago: Aflac/AHL/Aetna, SBLI, Transamerica Standard\n  - Treatment within 2 years: Corebridge SIWL (stage 1/2), or Corebridge Graded/Guaranteed Issue\n  - Single Occurrence: CICA Standard\n  - Multiple Occurrences: Corebridge Guaranteed Issue\n  - Active Cancer/Treatment: Corebridge Guaranteed Issue`,
      },
      {
        label: "HEALTH ROUTING — KIDNEY / LIVER",
        text: `• Any Kidney or Liver Issues?\n  - If Kidney: "Do you have kidney disease, insufficiency, or failure? Are you currently on dialysis?"\n  - Kidney Disease: TransAmerica standard, Foresters Planright standard\n  - Dialysis: Corebridge Guaranteed Issue\n  - If Liver: "Is it cirrhosis of the liver?"\n  - Liver issues: Corebridge Guaranteed Issue`,
      },
      {
        label: "HEALTH ROUTING — HEART / STROKE / STENTS",
        text: `• Any Heart Attacks, Strokes, Stents, Seizures or Bypasses?\n  - If any of these: "How long ago was your _____ (Heart Attack, Stroke, Stent Placement)?"\n  - Stroke:\n    Over 2 years: Aflac/AHL/Aetna, TransAmerica, Royal Neighbors, Foresters Planright\n    1-2 years: Royal Neighbors, Aflac/AHL/Aetna Standard, TransAmerica Standard\n    Under 2 years: Corebridge Guaranteed Issue\n  - Heart Attack:\n    Over 2 years: Royal Neighbors, TransAmerica, Aflac/AHL/Aetna\n    1-2 years: TransAmerica, Aflac/AHL/Aetna Standard\n    Under 2 years: TransAmerica, Corebridge Guaranteed Issue\n  - Stents: Any Carrier except Mutual of Omaha & Foresters`,
      },
      {
        label: "HEALTH ROUTING — CHF / LUPUS / MS / PARKINSON'S / ALS",
        text: `• Any Congestive Heart Failure, Lupus, Multiple Sclerosis (MS), Parkinson's, or Lou Gherig's (ALS)?\n  - Congestive Heart Failure: TransAmerica, Corebridge Guaranteed Issue\n  - Lou Gherig's (ALS): Corebridge Guaranteed Issue\n  - Lupus (SLE): Royal Neighbors, TransAmerica, Foresters Planright Standard\n  - Multiple Sclerosis (MS): Foresters Planright, Royal Neighbors, TransAmerica, Aflac/AHL/Aetna\n  - Parkinson's: Royal Neighbors, SBLI, TransAmerica, Aflac/AHL/Aetna Standard, Foresters Planright Standard (if they are able to perform activities of daily living)`,
      },
      {
        label: "HEALTH ROUTING — ALZHEIMER'S / DEMENTIA / MOBILITY",
        text: `• Any Alzheimer's, Dementia, Wheelchair or Walker (Confinement/Dependency)?\n  - Alzheimer's/Dementia: Corebridge Guaranteed Issue\n  - Wheelchair or Walker confinements (except occasional use): TransAmerica, Corebridge Guaranteed Issue\n  Agent: "Do you have a condition that requires you to use of your wheelchair/scooter/walker?" (uncover additional health info)\n\n-Check the health grid and UW Guides to determine which app to start-\n-Now start an application-\n**If you're still unsure of which carrier to write with, ask a leader or trainer. We are here to help.**`,
      },
    ],
  },

  "Text Message Code": {
    type: "tool",
    sections: [
      {
        label: "TEXT MESSAGE / EMAIL CODE",
        text: `"You're going to receive a text message in a couple seconds. It's just to verify that you are the person you say you are, and to allow us to run a quick medical check to make sure you qualify for that (preferred plan/healthy option/permanent coverage/additional coverage). The message is going to come from (COMPANY NAME) and it will have a 6-digit code. I just need you to read that code back to me please."`,
      },
    ],
  },

  // ── NEW: AI Script content (triggered by robot icon click) ──
  "AI Script": {
    type: "script",
    sections: [
      {
        label: "OPENING & VERIFICATION",
        text: `Good morning/Good afternoon this is _______ I see that you were talking to my assistant about your final expense coverage, is that correct? Looks like she's trying to transfer some information but it’s still coming over to me. Just a moment… (quick subtle small talk)\n\nIs this _______ (customer name)?\n\nLet the customer respond\n\nPerfect, go ahead verify your date of birth?\n\nLet the customer respond\n\nDo you currently have life insurance in place?`,
      },
      {
        label: "IF YES",
        text: `Are you looking to review your current coverage, or do you think you’re under-insured?\n\n(gather info on current policy, pitch standard vs preferred/term vs perm/additional coverage)\n\nIf they don’t want to provide info on their current policy, read below`,
      },
      {
        label: "IF NO",
        text: `My assistant informed me that you want to make sure you cover your final expenses so you don’t leave a burden on a loved one, is that correct?\n\nPerfect, when you pass away are you looking to have a burial, cremation, and do you want a full funeral, or do you want to ensure you leave extra money behind for loved ones?\n\nAs you know, life insurance prices are based on 2 main factors. Age and health. Let me ask you this, are you still healthy?\n\nNo cancer, heart attack, stroke, COPD, diabetes?\nGather health info`,
      },
      {
        label: "HOOK / REACTIVATE OFFER",
        text: `Okay, well it’s showing me that a while ago, there was a preferred rate made available to you for a _______ (whole life) policy for _____ ($20k of total coverage) to cover your _____ (burial, cremation, etc.) Was there a reason you didn’t take advantage of that when it was first available? (Pause)\n\nWell how much was it?\n\nToday’s standard rate on that coverage is about $XXX.XX (scroll to the bottom or insurance toolkits), which I don’t want you to pay.\n(DO NOT GIVE THEM TIME TO RESPOND UNTIL AFTER YOU TELL THEM YOU DON’T WANT THEM TO PAY THAT) That’s why my assistant reached out to you because they tried to activate it for you at a preferred rate which would have been way cheaper. But you said no one reached out to you on that? You just didn’t know about it?\n\nNo, I had no idea!\n\nWell, obviously if you would have known about it, you would have taken advantage of that, correct?\n\nYes of course I would have!\n\nOkay, well here’s what I’m going to do (pause). I’m just going to see if they will let me go back and reinstate that, because like I said, it was never accepted or declined. Plus, you just didn’t know about it and that’s no fault of your own. I can’t make any promises,(THE TAKE AWAY, FEAR OF LOSS, HOPE FOR GAIN) but I’m going to try to pull some strings for you and see if they’ll let me go back and get it for you under that preferred rate, okay?\n\nLet the customer respond\n\nI’ll do everything I can. I’m just going to ask you a couple of quick questions to make sure you qualify for the preferred plan and to make sure we have the most up to date and accurate information.`,
      },
    ],
  },
};

/* ── Compliance Modal Data ── */
const complianceData = {
  rules: [
    {
      title: "No Misrepresentation",
      text: "Agents must never misrepresent themselves or the products they are selling.",
    },
    {
      title: "Ethical Conduct",
      text: "Agents must never place a client in a worse position than they are currently in.",
    },
    {
      title: "No Forgery",
      text: "Agents must never forge a client's signature or complete an application without the client's explicit consent.",
    },
    {
      title: "Direct Sales Only",
      text: 'Agents must never "ghost-write" business or allow others to use their agent code.',
    },
    {
      title: "PII Security",
      text: "Agents must never record or store a client's Social Security Number or banking information on any personal device.",
    },
    {
      title: "TCPA Compliance",
      text: "Agents must never contact individuals on the National Do Not Call Registry unless a valid business relationship exists.",
    },
  ],
  misrepExamples: [
    "Claiming to be from the Social Security Administration or any government agency.",
    'Stating that a policy is "free" or a "government benefit."',
    "Providing false information about waiting periods or coverage limits.",
  ],
};

/* ── Data ── */
const scriptCategories = [
  ["Greeting", "Gathering Information"],
  ["New Policy Quote", "Healthy vs Unhealthy V1"],
  ["Healthy vs Unhealthy V2", "Temporary vs Permanent V1"],
  ["Temporary vs Permanent V2", "Standard vs Preferred"],
  ["Premium Reduction", "Additional Coverage"],
  ["Interest-Free Cash Surrender", "Cash Value Statement"],
  ["Consolidation", "Extension of Coverage"],
  ["Death Claim", "Non-Life Insurance Calls"],
];

const quickTools = [
  { icon: <PeopleIcon />, label: "Gathering Beneficiary Info" },
  { icon: <ChatIcon />, label: "Say This BEFORE Your 3-Choice Close" },
  {
    icon: <ArrowsIcon />,
    label: "Say This BEFORE Your 3-Choice Close (Term vs Perm)",
  },
  {
    icon: <SwitchIcon />,
    label: "Say This BEFORE Your 3-Choice Close (UL to WL)",
  },
  { icon: <ListIcon />, label: "3 Choice Close" },
  { icon: <BankIcon />, label: "Gathering Banking Info" },
  { icon: <NoteIcon />, label: "Additional Notes" },
  { icon: <LockIcon />, label: "The Button Up" },
];

/* ── Compliance Modal ── */
function ComplianceModal({ onClose }) {
  useEffect(() => {
    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };

    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
    document.addEventListener("keydown", handleKey);

    return () => {
      document.removeEventListener("keydown", handleKey);
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [onClose]);

  const modalContent = (
    <>
      {/* Overlay */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.72)",
          zIndex: 9996,
          animation: "fadeInOverlay 0.2s ease",
        }}
      />

      {/* Modal */}
      <div
        style={{
          position: "fixed",
          top: "56px",
          bottom: "24px",
          left: "50%",
          transform: "translateX(-50%)",
          width: "min(760px, calc(100vw - 32px))",
          height: "calc(100vh - 80px)",
          maxHeight: "calc(100vh - 80px)",
          background: "#0d0d0d",
          border: "1px solid #7a3010",
          borderRadius: "12px",
          zIndex: 9997,
          display: "flex",
          flexDirection: "column",
          animation: "fadeInOverlay 0.18s ease",
          overflow: "hidden",
        }}
      >
        {/* Modal Header */}
        <div
          style={{
            padding: "24px 32px 18px",
            borderBottom: "1px solid #2a1008",
            background: "#100a06",
            flexShrink: 0,
            display: "flex",
            alignItems: "flex-start",
            gap: "16px",
          }}
        >
          <div
            style={{
              width: "44px",
              height: "44px",
              background: "#1a0a06",
              border: "1px solid #7a3010",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <svg
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#ffb4ab"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
          </div>
          <div style={{ flex: 1 }}>
            <p
              style={{
                fontSize: "10px",
                fontWeight: 700,
                letterSpacing: "0.2em",
                color: "#ffb4ab",
                marginBottom: "6px",
              }}
            >
              NON-NEGOTIABLE
            </p>
            <h2
              style={{
                fontSize: "clamp(18px, 3vw, 26px)",
                fontWeight: 700,
                color: "#ffffff",
                letterSpacing: "0.04em",
              }}
            >
              SALES COMPLIANCE REQUIREMENTS
            </h2>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              color: "#5a7a90",
              cursor: "pointer",
              padding: "6px",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              transition: "color 0.18s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#ffffff")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#5a7a90")}
          >
            <CloseIcon />
          </button>
        </div>

        {/* Modal Body */}
        <div style={{ flex: 1, minHeight: 0, overflowY: "auto", padding: "24px 32px" }}>
          {/* Warning Banner */}
          <div
            style={{
              background: "#1a0a06",
              border: "1px solid #7a3010",
              borderRadius: "8px",
              padding: "16px 20px",
              marginBottom: "24px",
              fontSize: "12px",
              fontWeight: 700,
              letterSpacing: "0.12em",
              color: "#ffb4ab",
              lineHeight: 1.6,
            }}
          >
            THE FOLLOWING RULES ARE NON-NEGOTIABLE. FAILURE TO ADHERE TO THESE
            POLICIES WILL RESULT IN IMMEDIATE TERMINATION.
          </div>

          {/* Rules List */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "14px",
              marginBottom: "28px",
            }}
          >
            {complianceData.rules.map((rule, i) => (
              <div
                key={i}
                style={{
                  display: "flex",
                  gap: "16px",
                  background: "#0f0f0f",
                  border: "1px solid #1a1a1a",
                  borderRadius: "8px",
                  padding: "16px 20px",
                }}
              >
                <div
                  style={{
                    width: "28px",
                    height: "28px",
                    background: "#1a0a06",
                    border: "1px solid #4a1a08",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "12px",
                    fontWeight: 700,
                    color: "#ffb4ab",
                    flexShrink: 0,
                    marginTop: "1px",
                  }}
                >
                  {i + 1}
                </div>
                <div>
                  <p
                    style={{
                      fontSize: "13px",
                      fontWeight: 700,
                      color: "#ffffff",
                      marginBottom: "4px",
                    }}
                  >
                    {rule.title}
                  </p>
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#8aa0b0",
                      lineHeight: 1.7,
                    }}
                  >
                    {rule.text}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Misrepresentation Examples */}
          <div
            style={{
              background: "#120804",
              border: "1px solid #4a1a08",
              borderRadius: "8px",
              padding: "20px 24px",
            }}
          >
            <p
              style={{
                fontSize: "11px",
                fontWeight: 700,
                letterSpacing: "0.15em",
                color: "#ffb4ab",
                marginBottom: "14px",
              }}
            >
              EXAMPLES OF MISREPRESENTATION:
            </p>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {complianceData.misrepExamples.map((ex, i) => (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "flex-start",
                  }}
                >
                  <span
                    style={{
                      width: "6px",
                      height: "6px",
                      background: "#ffb4ab",
                      borderRadius: "50%",
                      flexShrink: 0,
                      marginTop: "7px",
                    }}
                  />
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#c08070",
                      lineHeight: 1.7,
                    }}
                  >
                    {ex}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Modal Footer */}
        <div
          style={{
            padding: "18px 32px",
            borderTop: "1px solid #1a1008",
            background: "#0a0a0a",
            display: "flex",
            gap: "12px",
            flexShrink: 0,
          }}
        >
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding: "13px",
              background: "transparent",
              border: "1px solid #2a2a2a",
              borderRadius: "6px",
              color: "#6a8a9a",
              fontSize: "12px",
              fontWeight: 700,
              letterSpacing: "0.12em",
              cursor: "pointer",
              fontFamily: "inherit",
              transition: "border-color 0.18s, color 0.18s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#5a7a90";
              e.currentTarget.style.color = "#ffffff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#2a2a2a";
              e.currentTarget.style.color = "#6a8a9a";
            }}
          >
            CLOSE
          </button>
          <button
            onClick={onClose}
            style={{
              flex: 2,
              padding: "13px",
              background: "#d4a017",
              border: "none",
              borderRadius: "6px",
              color: "#000000",
              fontSize: "12px",
              fontWeight: 700,
              letterSpacing: "0.12em",
              cursor: "pointer",
              fontFamily: "inherit",
              transition: "background 0.18s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#e6b020")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#d4a017")}
          >
            I UNDERSTAND & AGREE
          </button>
        </div>
      </div>
    </>
  );

  if (typeof document !== "undefined") {
    return createPortal(modalContent, document.body);
  }

  return modalContent;
}


/* ── Script Drawer ── */
const instructionWords = new Set([
  "pause",
  "smile",
  "emphasize",
  "laugh",
  "repeat",
]);

const renderScriptInline = (text, keyPrefix) => {
  const parts = [];
  const pattern = /(_{2,}\s*(?:\([^)]*\))?|\([^)]*\))/g;
  let cursor = 0;
  let matchIndex = 0;
  let match;

  while ((match = pattern.exec(text)) !== null) {
    if (match.index > cursor) {
      parts.push(text.slice(cursor, match.index));
    }

    const token = match[0];
    const parenMatch = token.match(/\(([^)]*)\)/);
    const rawLabel = parenMatch?.[1]?.trim();
    const normalized = rawLabel?.toLowerCase();
    const isInstruction = rawLabel && instructionWords.has(normalized);
    const isStandaloneVariable =
      rawLabel && !isInstruction && (/^\$/.test(rawLabel) || /^[A-Z0-9]/.test(rawLabel));
    const isVariable = token.includes("__") || isStandaloneVariable;

    if (isInstruction) {
      parts.push(
        <span className="sr-reader-instruction" key={`${keyPrefix}-instruction-${matchIndex}`}>
          ⏸ {rawLabel}
        </span>
      );
    } else if (isVariable) {
      parts.push(
        <span className="sr-reader-pill" key={`${keyPrefix}-pill-${matchIndex}`}>
          {rawLabel || "Field"}
        </span>
      );
    } else {
      parts.push(token);
    }

    cursor = pattern.lastIndex;
    matchIndex += 1;
  }

  if (cursor < text.length) {
    parts.push(text.slice(cursor));
  }

  return parts;
};

const isReaderHeading = (line) => {
  const trimmed = line.trim();
  if (!trimmed || trimmed.length > 64) return false;
  if (/^(Agent|Caller)\s*:/i.test(trimmed)) return false;
  return /[A-Z]/.test(trimmed) && trimmed === trimmed.toUpperCase();
};

const renderScriptText = (text, sectionIndex) =>
  text.split("\n").map((line, lineIndex) => {
    const key = `script-line-${sectionIndex}-${lineIndex}`;
    const speakerMatch = line.match(/^\s*(Agent|Caller)\s*:\s*(.*)$/i);

    if (!line.trim()) {
      return <div className="sr-reader-spacer" key={key} aria-hidden="true" />;
    }

    if (speakerMatch) {
      const speaker = speakerMatch[1].toLowerCase();
      const isAgent = speaker === "agent";

      return (
        <div
          className={`sr-reader-turn ${isAgent ? "agent" : "caller"}`}
          key={key}
        >
          <div className={`sr-reader-speaker ${isAgent ? "agent" : "caller"}`}>
            {isAgent ? "👤 AGENT" : "☎ CALLER"}
          </div>
          <div className="sr-reader-quote">
            {renderScriptInline(speakerMatch[2], key)}
          </div>
        </div>
      );
    }

    if (isReaderHeading(line)) {
      return (
        <div className="sr-reader-heading" key={key}>
          {line.trim()}
        </div>
      );
    }

    return (
      <div className="sr-reader-line" key={key}>
        {renderScriptInline(line, key)}
      </div>
    );
  });

function ScriptDrawer({ label, onClose, resetKey, inline = false }) {
  const data = scriptData[label];
  const isObjection = data?.type === "objection";
  const accentColor = isObjection ? "#ffb4ab" : "#06b6d4";
  const drawerRef = useRef(null);
  const bodyRef = useRef(null);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [onClose]);

  useEffect(() => {
    const resetScroll = (element) => {
      if (!element) return;

      try {
        element.scrollTo({ top: 0, left: 0, behavior: "auto" });
      } catch {
        element.scrollTop = 0;
      }

      window.setTimeout(() => {
        element.scrollTop = 0;
      }, 350);
    };

    const frameId = requestAnimationFrame(() => {
      resetScroll(drawerRef.current);
      resetScroll(bodyRef.current);
    });

    return () => cancelAnimationFrame(frameId);
  }, [label, resetKey]);

  if (!data) return null;

  const drawerContent = (
    <>
      {!inline && (
        <div
          onClick={onClose}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.72)",
            zIndex: 9998,
            animation: "fadeInOverlay 0.2s ease",
            backdropFilter: "blur(4px)",
          }}
        />
      )}

      {/* Drawer */}
      <div
        ref={drawerRef}
        className={inline ? "sr-inline-drawer" : "sr-script-drawer"}
        style={{
          position: inline ? "relative" : "fixed",
          top: inline ? "auto" : 0,
          right: inline ? "auto" : 0,
          width: inline ? "100%" : "50vw",
          maxWidth: inline ? undefined : "880px",
          minWidth: inline ? undefined : "540px",
          height: inline ? "clamp(440px, 52vh, 760px)" : "100vh",
          maxHeight: inline ? undefined : "100vh",
          background: inline
            ? "#0f1318"
            : "radial-gradient(circle at 20% 0%, rgba(6,182,212,0.16), transparent 30%), linear-gradient(145deg, rgba(13,22,28,0.96), rgba(5,8,12,0.98))",
          borderLeft: inline ? "1px solid rgba(6, 182, 212, 0.22)" : "1px solid rgba(6, 182, 212, 0.36)",
          border: inline ? "1px solid rgba(6, 182, 212, 0.22)" : undefined,
          borderRadius: inline ? "18px" : 0,
          zIndex: inline ? 1 : 9999,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxShadow: inline
            ? undefined
            : "-28px 0 80px rgba(0,0,0,0.48), 0 0 36px rgba(6,182,212,0.12), inset 1px 0 0 rgba(255,255,255,0.05)",
          backdropFilter: inline ? undefined : "blur(18px)",
          animation: inline
            ? "sr-inline-drawer-in 260ms cubic-bezier(0.16,1,0.3,1)"
            : "slideInDrawer 0.25s cubic-bezier(0.16,1,0.3,1)",
        }}
      >
        {/* Drawer Header */}
        <div
          style={{
            padding: "32px 32px 24px",
            borderBottom: "1px solid rgba(6, 182, 212, 0.22)",
            position: "sticky",
            top: 0,
            zIndex: 2,
            background: inline
              ? "rgba(15, 19, 24, 0.94)"
              : "linear-gradient(180deg, rgba(10,17,22,0.98), rgba(10,17,22,0.9))",
            flexShrink: 0,
          }}
        >
          <p
            style={{
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "0.2em",
              color: accentColor,
              marginBottom: "8px",
            }}
          >
            MODULE ACTIVE
          </p>
          <h2
            style={{
              fontSize: "clamp(18px, 3vw, 28px)",
              fontWeight: 700,
              letterSpacing: "0.04em",
              color: "#ffffff",
              lineHeight: 1.1,
              paddingRight: "40px",
            }}
          >
            {label.toUpperCase()} SCRIPT
          </h2>
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              top: "24px",
              right: "24px",
              background: "transparent",
              border: "none",
              color: "#5a7a90",
              cursor: "pointer",
              padding: "6px",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "color 0.18s",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.color = "#ffffff")}
            onMouseLeave={(e) => (e.currentTarget.style.color = "#5a7a90")}
          >
            <CloseIcon />
          </button>
        </div>

        {/* Drawer Body */}
        <div
          ref={bodyRef}
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            padding: "28px 32px 36px",
            color: "#eaf8ff",
            fontFamily:
              "'Inter', 'Geist', 'Manrope', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          }}
        >
          {data.sections.map((section, i) => (
            <div className="sr-reader-card" key={i}>
              {/* Section Label */}
              <div
                className="sr-reader-section-title"
                style={{
                  color: accentColor,
                }}
              >
                <span
                  style={{
                    width: "8px",
                    height: "8px",
                    background: accentColor,
                    borderRadius: "50%",
                    flexShrink: 0,
                    display: "inline-block",
                  }}
                />
                {section.label}
              </div>

              {/* Script Block */}
              <div className="sr-reader-body">{renderScriptText(section.text, i)}</div>
            </div>
          ))}
        </div>
      </div>
    </>
  );

  if (!inline && typeof document !== "undefined") {
    return createPortal(drawerContent, document.body);
  }

  return drawerContent;
}

/* ── Main Component ── */
export default function Scripts() {
  const [activeScript, setActiveScript] = useState(null);
  const [activeModule, setActiveModule] = useState("Master App");
  const [showCompliance, setShowCompliance] = useState(false);
  const [drawerResetKey, setDrawerResetKey] = useState(0);
  const [search, setSearch] = useState("");
  const pageRef = useRef(null);

  const normalizedSearch = search.trim().toLowerCase();
  const filteredScriptLabels = scriptCategories
    .flat()
    .filter(Boolean)
    .filter((label) => label.toLowerCase().includes(normalizedSearch));
  const showLivingBenefitsFooter =
    !normalizedSearch ||
    "Living Benefits / FREE Option".toLowerCase().includes(normalizedSearch);
  const showObjectionFooter =
    !normalizedSearch ||
    "Objection Handling".toLowerCase().includes(normalizedSearch);
  const filteredQuickTools = quickTools.filter(({ label }) =>
    label.toLowerCase().includes(normalizedSearch)
  );

  const openDrawer = useCallback((label) => {
    window.scrollTo(0, 0);
    document.scrollingElement?.scrollTo?.(0, 0);
    document.querySelector(".portal-main")?.scrollTo?.(0, 0);
    if (pageRef.current) pageRef.current.scrollTop = 0;

    setActiveScript(label);
    setDrawerResetKey((key) => key + 1);
  }, []);
  const closeDrawer = useCallback(() => setActiveScript(null), []);
  const openCompliance = useCallback(() => setShowCompliance(true), []);
  const closeCompliance = useCallback(() => setShowCompliance(false), []);

  useEffect(() => {
    document.documentElement.classList.add("scripts-page-active");
    document.body.classList.add("scripts-page-active");

    return () => {
      document.documentElement.classList.remove("scripts-page-active");
      document.body.classList.remove("scripts-page-active");
    };
  }, []);

  return (
    <div
      ref={pageRef}
      className="sr-page"
      style={{
        minHeight: "auto",
        height: "auto",
        color: "#c8d8e8",
        fontFamily: "'DM Sans', 'Helvetica Neue', Arial, sans-serif",
        overflowX: "hidden",
      }}
    >
      <span className="sr-page-scan" aria-hidden="true" />
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&family=Inter:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }

        @keyframes pulse-live {
          0%, 100% { opacity: 1; box-shadow: 0 0 0 0 rgba(6,182,212,0.34), 0 0 12px rgba(6,182,212,0.4); }
          50% { opacity: 0.62; box-shadow: 0 0 0 6px rgba(6,182,212,0), 0 0 22px rgba(6,182,212,0.55); }
        }
        @keyframes sr-page-in {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes sr-mesh-drift {
          from { transform: translate3d(-2%, -1%, 0) scale(1); }
          to { transform: translate3d(2%, 1%, 0) scale(1.04); }
        }
        @keyframes sr-scan-line {
          from { transform: translateX(-120%); opacity: 0; }
          20%, 80% { opacity: 0.55; }
          to { transform: translateX(120%); opacity: 0; }
        }
        @keyframes sr-title-glow {
          0%, 100% { opacity: 0.44; transform: translateX(-2%) scale(1); }
          50% { opacity: 0.74; transform: translateX(2%) scale(1.03); }
        }
        @keyframes sr-card-enter {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes sr-border-pulse {
          0%, 100% { box-shadow: 0 0 0 rgba(6,182,212,0), inset 0 1px 0 rgba(255,255,255,0.04); }
          50% { box-shadow: 0 0 28px rgba(6,182,212,0.09), inset 0 1px 0 rgba(255,255,255,0.065); }
        }
        @keyframes fadeInOverlay {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideInDrawer {
          from { transform: translateX(100%); }
          to { transform: translateX(0); }
        }
        @keyframes sr-inline-drawer-in {
          from { opacity: 0; transform: translateY(14px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes sr-grid-drift {
          from { background-position: 0 0; }
          to { background-position: 42px 42px; }
        }
        @keyframes sr-dashboard-scan {
          0%, 100% { background-position: 0 -260px, 0 0; }
          50% { background-position: 0 100vh, 0 0; }
        }
        @keyframes scaleInModal {
          from { opacity: 0; transform: translate(-50%, -48%) scale(0.96); }
          to { opacity: 1; transform: translate(-50%, -50%) scale(1); }
        }

        .sr-page {
          position: relative;
          isolation: isolate;
          min-height: auto;
          height: auto;
          padding-bottom: 0;
          background:
            radial-gradient(circle at 16% 9%, rgba(6, 182, 212, 0.16), transparent 28%),
            radial-gradient(circle at 82% 4%, rgba(212, 160, 23, 0.11), transparent 24%),
            radial-gradient(circle at 70% 68%, rgba(6, 182, 212, 0.08), transparent 32%),
            #07090c;
          animation: sr-page-in 320ms ease both;
        }
        .sr-page::before {
          content: "";
          position: absolute;
          inset: 0;
          z-index: -2;
          pointer-events: none;
          opacity: 0.42;
          background:
            linear-gradient(rgba(6, 182, 212, 0.045) 1px, transparent 1px),
            linear-gradient(90deg, rgba(212, 160, 23, 0.033) 1px, transparent 1px);
          background-size: 42px 42px;
          mask-image: radial-gradient(circle at 50% 16%, black, transparent 75%);
          animation: sr-grid-drift 18s linear infinite;
        }
        .sr-page::after {
          content: "";
          position: absolute;
          inset: -18%;
          z-index: -3;
          pointer-events: none;
          opacity: 0.4;
          background:
            radial-gradient(circle at 22% 22%, rgba(6, 182, 212, 0.17), transparent 22%),
            radial-gradient(circle at 76% 18%, rgba(212, 160, 23, 0.12), transparent 20%),
            radial-gradient(circle at 52% 72%, rgba(6, 182, 212, 0.09), transparent 26%);
          filter: blur(20px);
          animation: sr-mesh-drift 18s ease-in-out infinite alternate;
        }
        .sr-page .sr-page-scan {
          position: absolute;
          inset: 0;
          pointer-events: none;
          z-index: -1;
          opacity: 0.12;
          background:
            linear-gradient(180deg, transparent 0%, rgba(6,182,212,0.18) 48%, transparent 52%),
            radial-gradient(circle at 72% 76%, rgba(6,182,212,0.2), transparent 24%);
          background-size: 100% 260px, 100% 100%;
          animation: sr-dashboard-scan 8s ease-in-out infinite;
        }
        .sr-shell {
          position: relative;
          max-width: 1520px;
          margin: 0 auto;
        }
        .sr-header {
          position: relative;
          overflow: hidden;
          border: 1px solid rgba(6, 182, 212, 0.12);
          border-top: 0;
          background: linear-gradient(135deg, rgba(12, 18, 23, 0.78), rgba(5, 8, 12, 0.58));
          backdrop-filter: blur(14px);
          box-shadow: 0 22px 60px rgba(0,0,0,0.2), inset 0 1px 0 rgba(255,255,255,0.04);
        }
        .sr-header::before {
          content: "";
          position: absolute;
          width: min(680px, 78vw);
          height: 190px;
          left: 10px;
          top: -70px;
          background: radial-gradient(ellipse, rgba(6,182,212,0.26), rgba(212,160,23,0.08) 38%, transparent 68%);
          filter: blur(12px);
          animation: sr-title-glow 7s ease-in-out infinite;
          pointer-events: none;
        }
        .sr-header::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 1px;
          background: linear-gradient(90deg, transparent, rgba(6,182,212,0.72), rgba(212,160,23,0.5), transparent);
          animation: sr-scan-line 5.5s ease-in-out infinite;
        }
        .sr-header > * {
          position: relative;
          z-index: 1;
        }
        .sr-live-badge {
          background: rgba(6, 24, 31, 0.74);
          border: 1px solid rgba(6, 182, 212, 0.26);
          box-shadow: 0 0 24px rgba(6, 182, 212, 0.08), inset 0 1px 0 rgba(255,255,255,0.04);
          backdrop-filter: blur(12px);
        }
        .sr-compliance-card,
        .sr-tool-console {
          position: relative;
          overflow: hidden;
          background: linear-gradient(145deg, rgba(13, 22, 28, 0.78), rgba(7, 10, 13, 0.88));
          border: 1px solid rgba(6, 182, 212, 0.26);
          box-shadow: 0 20px 54px rgba(0,0,0,0.24), 0 0 28px rgba(6,182,212,0.08), inset 0 1px 0 rgba(255,255,255,0.045);
          backdrop-filter: blur(14px);
          animation: sr-card-enter 360ms ease both, sr-border-pulse 5s ease-in-out infinite;
        }
        .sr-compliance-card::before,
        .sr-tool-console::before,
        .sr-ai-card::before,
        .sr-script-row::before {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: linear-gradient(110deg, transparent 0%, rgba(255,255,255,0.075) 42%, transparent 62%);
          transform: translateX(-130%);
          transition: transform 720ms ease;
        }
        .sr-compliance-card:hover::before,
        .sr-tool-console:hover::before,
        .sr-ai-card:hover::before,
        .sr-script-row:hover::before {
          transform: translateX(130%);
        }
        .sr-section-label {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 10px;
        }
        .sr-section-label::before {
          content: "";
          width: 28px;
          height: 1px;
          background: currentColor;
          box-shadow: 0 0 14px currentColor;
        }

        .sr-script-row {
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 9px 12px;
          background: linear-gradient(145deg, rgba(13, 18, 22, 0.84), rgba(9, 12, 14, 0.88));
          border: 1px solid rgba(212, 160, 23, 0.16);
          border-radius: 8px;
          cursor: pointer;
          font-size: 12.5px;
          color: #ffffff;
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.035);
          transition: transform 0.22s ease, border-color 0.22s ease, color 0.22s ease, background 0.22s ease, box-shadow 0.22s ease;
          gap: 8px;
          animation: sr-card-enter 360ms ease both;
        }
        .sr-script-row:hover {
          transform: translateY(-3px);
          border-color: rgba(6, 182, 212, 0.72);
          color: #e0f8ff;
          background: linear-gradient(145deg, rgba(10, 24, 31, 0.9), rgba(9, 13, 17, 0.9));
          box-shadow: 0 16px 36px rgba(0,0,0,0.28), 0 0 24px rgba(6,182,212,0.13), inset 0 1px 0 rgba(255,255,255,0.05);
        }
        .sr-script-row.danger {
          background: linear-gradient(145deg, rgba(80, 18, 18, 0.92), rgba(38, 8, 8, 0.92));
          border-color: rgba(255, 88, 88, 0.42);
          color: #ffffff;
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.045), 0 0 20px rgba(255, 88, 88, 0.08);
        }
        .sr-script-row.danger:hover {
          background: linear-gradient(145deg, rgba(108, 25, 25, 0.96), rgba(48, 10, 10, 0.96));
          border-color: rgba(255, 120, 120, 0.82);
          color: #ffffff;
          box-shadow: 0 16px 36px rgba(0,0,0,0.28), 0 0 26px rgba(255, 88, 88, 0.2), inset 0 1px 0 rgba(255,255,255,0.06);
        }
        .sr-script-row.danger svg {
          color: #ffb4ab;
          filter: drop-shadow(0 0 8px rgba(255, 88, 88, 0.36));
        }
        .sr-script-row svg {
          transition: transform 0.22s ease, filter 0.22s ease;
        }
        .sr-script-row:hover svg {
          transform: translateX(4px);
          filter: drop-shadow(0 0 8px rgba(6,182,212,0.5));
        }

        .sr-quick-row {
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          gap: 7px;
          padding: 6px 10px;
          background: rgba(9, 15, 20, 0.78);
          border: 1px solid rgba(6, 182, 212, 0.12);
          border-radius: 8px;
          cursor: pointer;
          font-size: 11.25px;
          color: #ffffff;
          transition: transform 0.2s ease, border-color 0.2s ease, color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
        }
        .sr-quick-row:hover {
          transform: translateY(-2px);
          border-color: rgba(6,182,212,0.58);
          color: #e0f8ff;
          background: rgba(8, 26, 34, 0.84);
          box-shadow: 0 12px 26px rgba(0,0,0,0.22), 0 0 18px rgba(6,182,212,0.1);
        }
        .sr-quick-row.active { border-color: #06b6d4; background: #071820; color: #e0f8ff; }

        .sr-module-tab {
          flex: 1;
          padding: 4px 8px;
          background: transparent;
          border: none;
          font-family: inherit;
          font-size: 11.5px;
          color: #5a7a90;
          cursor: pointer;
          text-align: left;
          border-top: 2px solid transparent;
          transition: color 0.18s, border-color 0.18s, background 0.18s;
        }
        .sr-module-tab.active { color: #06b6d4; border-top-color: #06b6d4; background: rgba(6,182,212,0.055); }
        .sr-module-tab:hover { color: #06b6d4; background: rgba(6,182,212,0.04); }

        .sr-compliance-btn {
          background: rgba(6,182,212,0.055);
          border: 1px solid rgba(6,182,212,0.68);
          color: #99f6ff;
          padding: 11px 22px;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 0.12em;
          border-radius: 5px;
          cursor: pointer;
          font-family: inherit;
          white-space: nowrap;
          box-shadow: 0 0 18px rgba(6,182,212,0.08);
          transition: transform 0.2s ease, background 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
          flex-shrink: 0;
        }
        .sr-compliance-btn:hover {
          transform: translateY(-2px);
          background: rgba(6,182,212,0.12);
          border-color: #06b6d4;
          box-shadow: 0 0 28px rgba(6,182,212,0.18);
        }

        .sr-main-grid {
          display: grid;
          grid-template-columns: minmax(0, 1.85fr) minmax(320px, 1fr);
          gap: clamp(12px, 1.3vw, 16px);
          align-items: stretch;
          min-height: 0;
        }
        @media (max-width: 1180px) {
          .sr-script-drawer {
            width: 60vw !important;
            min-width: 0 !important;
          }
        }
        @media (max-width: 860px) { .sr-main-grid { grid-template-columns: 1fr; } }

        .sr-cat-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 6px;
          align-content: start;
        }
        .sr-category-footer-row {
          margin-top: 6px;
          width: 100%;
        }
        @media (max-width: 480px) { .sr-cat-grid { grid-template-columns: 1fr; } }

        .sr-compliance-inner {
          display: flex;
          gap: 24px;
          align-items: flex-start;
          justify-content: space-between;
        }
        @media (max-width: 600px) {
          .sr-compliance-inner { flex-direction: column; }
          .sr-compliance-btn { align-self: flex-start; }
        }
        .sr-ai-card {
          position: relative;
          overflow: hidden;
          background:
            radial-gradient(circle at 14% 15%, rgba(6,182,212,0.22), transparent 30%),
            linear-gradient(135deg, rgba(146,107,3,0.74) 0%, rgba(13,22,32,0.88) 45%, rgba(16,31,31,0.86) 100%);
          border: 1px solid rgba(6,182,212,0.2);
          box-shadow: 0 18px 44px rgba(0,0,0,0.24), 0 0 26px rgba(212,160,23,0.08);
          backdrop-filter: blur(14px);
          transition: transform 0.22s ease, border-color 0.22s ease, box-shadow 0.22s ease;
        }
        .sr-ai-card:hover {
          transform: translateY(-3px);
          border-color: rgba(6,182,212,0.48);
          box-shadow: 0 24px 54px rgba(0,0,0,0.28), 0 0 30px rgba(6,182,212,0.12), 0 0 28px rgba(212,160,23,0.09);
        }
        .sr-dashboard-shell {
          display: grid;
          gap: 8px;
          padding: 2px 16px 0 !important;
        }
        .sr-search-wrap {
          position: relative;
          margin: 0 auto;
          padding: 0 20px;
        }
        .sr-search-icon,
        .sr-clear-search {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 1;
        }
        .sr-search-icon {
          left: 38px;
          color: rgba(6, 182, 212, 0.76);
          filter: drop-shadow(0 0 10px rgba(6, 182, 212, 0.32));
        }
        .sr-clear-search {
          right: 32px;
          width: 34px;
          height: 34px;
          border: 1px solid rgba(212, 160, 23, 0.26);
          border-radius: 999px;
          background: rgba(212, 160, 23, 0.08);
          color: #d4a017;
          cursor: pointer;
          font-family: inherit;
        }
        .sr-search-input {
          width: 100%;
          min-height: 44px;
          border: 1px solid rgba(6, 182, 212, 0.22);
          border-radius: 16px;
          background: rgba(6, 12, 16, 0.76);
          color: #e0f8ff;
          padding: 0 58px;
          outline: none;
          font-family: inherit;
          font-size: 12px;
          letter-spacing: 0.06em;
          box-shadow: inset 0 1px 0 rgba(255,255,255,0.045), 0 16px 42px rgba(0,0,0,0.2);
          transition: border-color 0.22s ease, box-shadow 0.22s ease, background 0.22s ease;
        }
        .sr-search-input:focus {
          border-color: rgba(6, 182, 212, 0.68);
          background: rgba(8, 20, 26, 0.88);
          box-shadow: 0 0 0 4px rgba(6,182,212,0.08), 0 0 34px rgba(6,182,212,0.12);
        }
        .sr-search-input::placeholder {
          color: rgba(138, 160, 176, 0.62);
        }
        .sr-category-panel,
        .sr-tool-console {
          min-height: 0;
        }
        .sr-category-panel {
          position: relative;
          overflow: hidden;
          border: 1px solid rgba(6, 182, 212, 0.18);
          border-radius: 16px;
          background: linear-gradient(145deg, rgba(13, 22, 28, 0.64), rgba(7, 10, 13, 0.78));
          box-shadow: 0 20px 54px rgba(0,0,0,0.22), inset 0 1px 0 rgba(255,255,255,0.04);
          backdrop-filter: blur(14px);
          padding: 12px 12px 15px;
          height: auto;
          align-self: start;
        }
        .sr-tool-console {
          position: sticky;
          top: 16px;
          align-self: start;
          max-height: none;
          overflow-y: auto;
        }
        .sr-selected-panel {
          scroll-margin-top: 12px;
          padding-top: 0 !important;
        }
        .sr-inline-drawer {
          background:
            radial-gradient(circle at 18% 0%, rgba(6,182,212,0.14), transparent 28%),
            linear-gradient(145deg, rgba(13, 22, 28, 0.9), rgba(5, 8, 12, 0.94)) !important;
          box-shadow: 0 22px 62px rgba(0,0,0,0.3), 0 0 34px rgba(6,182,212,0.1), inset 0 1px 0 rgba(255,255,255,0.05);
          backdrop-filter: blur(14px);
        }
        .sr-script-drawer::before {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background:
            linear-gradient(90deg, rgba(6, 182, 212, 0.16), transparent 10%),
            repeating-linear-gradient(0deg, rgba(255,255,255,0.025) 0 1px, transparent 1px 26px);
          opacity: 0.46;
        }
        .sr-script-drawer > * {
          position: relative;
          z-index: 1;
        }
        .sr-reader-card {
          position: relative;
          overflow: hidden;
          margin-bottom: 24px;
          padding: 24px;
          border: 1px solid rgba(56, 189, 248, 0.2);
          border-radius: 16px;
          background:
            radial-gradient(circle at 12% 0%, rgba(56, 189, 248, 0.09), transparent 30%),
            linear-gradient(145deg, rgba(17, 28, 38, 0.9), rgba(9, 14, 20, 0.95));
          box-shadow:
            0 18px 44px rgba(0, 0, 0, 0.28),
            0 0 26px rgba(56, 189, 248, 0.08),
            inset 0 1px 0 rgba(255, 255, 255, 0.05);
        }
        .sr-reader-card::before {
          content: "";
          position: absolute;
          inset: 0;
          pointer-events: none;
          background: linear-gradient(110deg, transparent, rgba(255,255,255,0.055), transparent);
          transform: translateX(-120%);
          transition: transform 680ms ease;
        }
        .sr-reader-card:hover::before {
          transform: translateX(120%);
        }
        .sr-reader-section-title {
          display: flex;
          align-items: center;
          gap: 10px;
          padding-bottom: 12px;
          margin-bottom: 18px;
          border-bottom: 1px solid rgba(56, 189, 248, 0.24);
          font-size: clamp(16px, 1.7vw, 20px);
          font-weight: 800;
          letter-spacing: 0.1em;
          text-transform: uppercase;
        }
        .sr-reader-body {
          display: grid;
          gap: 10px;
          color: #f8fafc;
          font-family: "Inter", "Geist", "Manrope", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
          font-size: clamp(16px, 1.15vw, 18px);
          letter-spacing: 0.012em;
          line-height: 1.8;
        }
        .sr-reader-turn {
          padding: 12px 14px 12px 16px;
          border-radius: 12px;
          background: rgba(255,255,255,0.035);
        }
        .sr-reader-turn.agent {
          border-left: 3px solid #38bdf8;
          box-shadow: inset 1px 0 0 rgba(56, 189, 248, 0.18);
        }
        .sr-reader-turn.caller {
          border-left: 3px solid #4ade80;
          box-shadow: inset 1px 0 0 rgba(74, 222, 128, 0.16);
        }
        .sr-reader-speaker {
          margin-bottom: 6px;
          font-size: 1.02em;
          font-weight: 800;
          letter-spacing: 0.08em;
        }
        .sr-reader-speaker.agent {
          color: #38bdf8;
          text-shadow: 0 0 14px rgba(56, 189, 248, 0.24);
        }
        .sr-reader-speaker.caller {
          color: #4ade80;
          text-shadow: 0 0 14px rgba(74, 222, 128, 0.22);
        }
        .sr-reader-quote,
        .sr-reader-line {
          color: #f8fafc;
          font-weight: 500;
        }
        .sr-reader-line {
          padding: 4px 0;
        }
        .sr-reader-heading {
          margin-top: 8px;
          padding: 12px 0 8px;
          border-bottom: 1px solid rgba(56, 189, 248, 0.28);
          color: #38bdf8;
          font-size: clamp(17px, 1.4vw, 21px);
          font-weight: 800;
          letter-spacing: 0.12em;
          text-transform: uppercase;
        }
        .sr-reader-instruction {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          margin: 0 3px;
          padding: 2px 8px;
          border: 1px solid rgba(251, 146, 60, 0.34);
          border-radius: 999px;
          background: rgba(251, 146, 60, 0.1);
          color: #fb923c;
          font-size: 0.78em;
          font-style: italic;
          font-weight: 700;
          letter-spacing: 0.03em;
          vertical-align: baseline;
        }
        .sr-reader-pill {
          display: inline-flex;
          align-items: center;
          margin: 0 3px;
          padding: 2px 9px;
          border: 1px solid rgba(212, 160, 23, 0.42);
          border-radius: 999px;
          background: rgba(212, 160, 23, 0.12);
          color: #fde68a;
          font-size: 0.82em;
          font-weight: 800;
          letter-spacing: 0.04em;
          vertical-align: baseline;
          box-shadow: 0 0 16px rgba(212, 160, 23, 0.08);
        }
        .sr-reader-spacer {
          height: 8px;
        }
        .sr-empty-state {
          border: 1px dashed rgba(6, 182, 212, 0.22);
          border-radius: 12px;
          padding: 24px;
          color: rgba(138, 160, 176, 0.72);
          font-size: 12px;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          text-align: center;
        }
        .sr-tool-empty {
          color: rgba(138, 160, 176, 0.7);
          font-size: 12px;
          line-height: 1.6;
          padding: 12px;
          border: 1px dashed rgba(6, 182, 212, 0.16);
          border-radius: 10px;
        }
        .sr-compliance-card {
          margin-top: 0;
        }
        @media (max-width: 640px) {
          .sr-header {
            margin-left: 12px;
            margin-right: 12px;
            border-radius: 0 0 14px 14px;
          }
          .sr-compliance-card,
          .sr-tool-console,
          .sr-ai-card {
            border-radius: 10px !important;
          }
          .sr-tool-console {
            position: relative;
            top: auto;
            max-height: none;
          }
          .sr-search-wrap {
            padding: 0 12px;
          }
          .sr-script-drawer {
            width: 100vw !important;
            min-width: 0 !important;
            max-width: none !important;
          }
          .sr-search-icon {
            left: 28px;
          }
          .sr-clear-search {
            right: 24px;
          }
          .sr-dashboard-shell {
            padding-left: 12px !important;
            padding-right: 12px !important;
          }
        }
        @media (prefers-reduced-motion: reduce) {
          .sr-page,
          .sr-page::after,
          .sr-header::before,
          .sr-header::after,
          .sr-compliance-card,
          .sr-tool-console,
          .sr-ai-card,
          .sr-script-row,
          .sr-quick-row {
            animation: none !important;
            transition: none !important;
            transform: none !important;
          }
        }

        ::-webkit-scrollbar { width: 4px; }
        ::-webkit-scrollbar-track { background: transparent; }
        ::-webkit-scrollbar-thumb { background: #1a2a38; border-radius: 2px; }
      `}</style>

      {/* ── Header ── */}
      <div
        className="sr-header sr-shell"
        style={{
          padding: "20px 18px 16px",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "12px",
          margin: "0 auto 12px",
        }}
      >
        <div>
          <h1
            style={{
              fontSize: "clamp(22px, 4.5vw, 38px)",
              fontWeight: 700,
              letterSpacing: "0.04em",
              color: "#ffffff",
              lineHeight: 1.1,
              marginBottom: "6px",
            }}
          >
            AGENT SCRIPT REPOSITORY
          </h1>
          <p
            style={{
              fontSize: "11px",
              fontWeight: 700,
              letterSpacing: "0.2em",
              color: "#06b6d4",
            }}
          >
            SECURE PROTOCOL // VERIFIED SALES SCRIPTS
          </p>
        </div>
        <div
          className="sr-live-badge"
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            borderRadius: "20px",
            padding: "6px 12px",
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.14em",
            color: "#06b6d4",
            flexShrink: 0,
          }}
        >
          <LiveDot />
          LIVE DATABASE
        </div>
      </div>

      {/* ── Compliance Banner ── */}
      <div className="sr-shell sr-search-wrap sr-search-primary">
        <span className="sr-search-icon" aria-hidden="true">
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </span>
        <input
          className="sr-search-input"
          value={search}
          onChange={(event) => setSearch(event.target.value)}
          placeholder="Search scripts, categories, AI tools..."
          aria-label="Search scripts, categories, AI tools"
        />
        {search && (
          <button
            type="button"
            className="sr-clear-search"
            onClick={() => setSearch("")}
            aria-label="Clear script search"
          >
            X
          </button>
        )}
      </div>

      <div className="sr-shell" style={{ margin: "8px auto", padding: "0 18px" }}>
        <div
          className="sr-compliance-card"
          style={{
            borderRadius: "10px",
            padding: "10px 14px",
          }}
        >
          <div className="sr-compliance-inner">
            <div style={{ flex: 1 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginBottom: "6px",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    background: "#1a0c06",
                    border: "1px solid #7a3010",
                    borderRadius: "5px",
                    padding: "5px 10px",
                    fontSize: "11px",
                    fontWeight: 700,
                    letterSpacing: "0.1em",
                    color: "#ffb4ab",
                    flexShrink: 0,
                  }}
                >
                  <AlertTriangle />
                  NON-NEGOTIABLE RULES
                </div>
                <h2
                  style={{
                    fontSize: "clamp(15px, 2.5vw, 19px)",
                    fontWeight: 600,
                    color: "#ffffff",
                  }}
                >
                  Sales Compliance Requirements
                </h2>
              </div>
              <p
                style={{
                  fontSize: "12.5px",
                  color: "#d0c5af",
                  lineHeight: 1.45,
                  maxWidth: "520px",
                }}
              >
                These rules are non-negotiable. Agents must never misrepresent
                themselves, place a client in a worse position, forge
                signatures, ghost-write business, or mishandle personal
                information. Review before using scripts.
              </p>
            </div>
            <button className="sr-compliance-btn" onClick={openCompliance}>
              VIEW COMPLIANCE RULES
            </button>
          </div>
        </div>
      </div>

      {/* ── Main Content ── */}
      <div className="sr-shell sr-dashboard-shell">
        <div className="sr-main-grid">
          {/* Left: Script Categories */}
          <div className="sr-category-panel">
            <div
              className="sr-section-label"
              style={{ color: "#d4a017" }}
            >
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  letterSpacing: "0.18em",
                  color: "#d4a017",
                }}
              >
                SCRIPT CATEGORIES
              </span>
            </div>
            <div className="sr-cat-grid">
              {filteredScriptLabels.map((label, index) => {
                return (
                  <div
                    key={label}
                    className="sr-script-row"
                    role="button"
                    tabIndex={0}
                    style={{
                      animationDelay: `${index * 35}ms`,
                    }}
                    onClick={() => openDrawer(label)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === " ") {
                        event.preventDefault();
                        openDrawer(label);
                      }
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        minWidth: 0,
                      }}
                    >
                      <span>{label}</span>
                    </span>
                    <span style={{ color: "#ffffff", flexShrink: 0 }}>
                      <ChevronRight />
                    </span>
                  </div>
                );
              })}
              {filteredScriptLabels.length === 0 &&
                !showLivingBenefitsFooter &&
                !showObjectionFooter && (
                <div className="sr-empty-state" style={{ gridColumn: "1 / -1" }}>
                  No script categories match search.
                </div>
              )}
            </div>
            {showLivingBenefitsFooter && (
              <div
                className="sr-script-row sr-category-footer-row"
                role="button"
                tabIndex={0}
                onClick={() => openDrawer("Living Benefits / FREE Option")}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    openDrawer("Living Benefits / FREE Option");
                  }
                }}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    minWidth: 0,
                  }}
                >
                  <span>Living Benefits / FREE Option</span>
                </span>
                <span style={{ color: "#ffffff", flexShrink: 0 }}>
                  <ChevronRight />
                </span>
              </div>
            )}
            {showObjectionFooter && (
              <div
                className="sr-script-row danger sr-category-footer-row"
                role="button"
                tabIndex={0}
                onClick={() => openDrawer("Objection Handling")}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    openDrawer("Objection Handling");
                  }
                }}
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    minWidth: 0,
                  }}
                >
                  <AlertTriangle />
                  <span>Objection Handling</span>
                </span>
                <span style={{ color: "#ffffff", flexShrink: 0 }}>
                  <ChevronRight />
                </span>
              </div>
            )}
          </div>

          {/* Right: Quick Access Tools */}
          <div className="sr-tool-console" style={{ borderRadius: "12px", padding: "12px" }}>
            <div
              className="sr-section-label"
              style={{ color: "#06b6d4" }}
            >
              <span
                style={{
                  fontSize: "11px",
                  fontWeight: 700,
                  letterSpacing: "0.18em",
                  color: "#06b6d4",
                }}
              >
                QUICK ACCESS TOOLS
              </span>
            </div>

            {/* AI Script Card */}
            <div
              className="sr-ai-card"
              style={{
                borderRadius: "10px",
                padding: "10px",
                marginBottom: "6px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  marginBottom: "6px",
                }}
              >
                {/* Robot icon now clickable to open AI Script drawer */}
                <div
                  style={{
                    width: "30px",
                    height: "30px",
                    background: "#071220",
                    border: "1px solid #1a3040",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    transition: "border-color 0.18s, transform 0.1s",
                  }}
                  onClick={() => openDrawer("AI Script")}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.borderColor = "#06b6d4")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.borderColor = "#1a3040")
                  }
                >
                  <BotIcon />
                </div>
                <div
                  style={{
                    background: "#0d1a14",
                    border: "1px solid #1a4020",
                    borderRadius: "4px",
                    padding: "3px 7px",
                    fontSize: "9px",
                    fontWeight: 700,
                    letterSpacing: "0.12em",
                    color: "#4aaa70",
                  }}
                >
                  SYSTEM OVERRIDE
                </div>
              </div>
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "#e0f0f8",
                  marginBottom: "4px",
                }}
              >
                AI Script
              </div>
              <div
                style={{ fontSize: "10.5px", color: "#7b96a6", lineHeight: 1.25 }}
              >
                Dynamic real-time script adaptation for complex client
                scenarios.
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: "7px",
                  borderTop: "1px solid #1a2a38",
                  background: "#071218",
                  borderRadius: "0 0 6px 6px",
                  overflow: "hidden",
                }}
              >
                {["Master App", "Text Message Code"].map((tab) => (
                  <button
                    key={tab}
                    className={`sr-module-tab${
                      activeModule === tab ? " active" : ""
                    }`}
                    onClick={() => {
                      setActiveModule(tab);
                      openDrawer(tab);
                    }}
                  >
                    <div
                      style={{
                        fontSize: "9px",
                        letterSpacing: "0.12em",
                        color: "#3a5a6a",
                        marginBottom: "2px",
                      }}
                    >
                      MODULE {tab === "Master App" ? "01" : "02"}
                    </div>
                    {tab}
                  </button>
                ))}
              </div>
            </div>

            {/* Quick Tool Rows */}
            <div
              style={{ display: "flex", flexDirection: "column", gap: "6px" }}
            >
              {filteredQuickTools.map(({ icon, label }, index) => (
                <div
                  key={label}
                  className={`sr-quick-row${
                    activeScript === label ? " active" : ""
                  }`}
                  style={{ animation: "sr-card-enter 360ms ease both", animationDelay: `${index * 35}ms` }}
                  onClick={() => openDrawer(label)}
                >
                  <span style={{ flexShrink: 0 }}>{icon}</span>
                  <span style={{ flex: 1 }}>{label}</span>
                </div>
              ))}
              {filteredQuickTools.length === 0 && normalizedSearch && (
                <div className="sr-tool-empty">
                  No quick tools match the current search.
                </div>
              )}

            </div>
          </div>
        </div>
      </div>

      {/* ── Script Drawer ── */}
      {activeScript && (
        <ScriptDrawer
          label={activeScript}
          onClose={closeDrawer}
          resetKey={drawerResetKey}
        />
      )}

      {/* ── Compliance Modal ── */}
      {showCompliance && <ComplianceModal onClose={closeCompliance} />}
    </div>
  );
}
